// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import './homeStyle.css';
// import Navbar from '../../Components/Navbar';
// import Footer from '../../Components/Footer/Footer';
// import Banner from '../../Assets/HELP.jpg'
// import axios from 'axios';

// const Home = () => {

//     const [services, setServices] = useState([]);
//     const navigate = useNavigate();

//     useEffect(() => {
//         // window.scrollTo(0, 0);
//         fetchServices();
//     }, []);

//     const fetchServices = async () => {
//         try {
//             const response = await axios.get('http://localhost:4001/services');
//             setServices(response.data);
//         } catch (error) {
//             console.error('Error fetching services:', error);
//         }
//     };

//     const handleCardClick = (serviceName) => {
//         const servicePath = serviceName.toLowerCase().replace(/\s+/g, '-');
//         navigate(`/services/${servicePath}`);
//     };

//     return (
//         <>
//             <Navbar />
//             <div className="home-content">
//                 <div className="left-content">
//                     <h1>Welcome to <br /><span>HelpNao</span></h1>
//                     <p>Discover HelpNao, your ultimate destination for seamless connections between users and servitors.
//                         Experience the ease of accessing essential services and providing valuable assistance,
//                         all in one platform. Join us today to unlock a world of mutual support and collaboration.</p>
//                 </div>
//                 <div className="right-content">
//                     <img src={Banner} alt="" />
//                 </div>
//             </div>

//             <div className="services">
//                 <h2>Our Services</h2>
//                 <div className="service-cards">
//                     {Array.from({ length: Math.ceil(services.length / 3) }).map((_, rowIndex) => (
//                         <React.Fragment key={rowIndex}>
//                             <div className="service-card-row">
//                                 {services.slice(rowIndex * 3, rowIndex * 3 + 3).map((service, cardIndex) => (
//                                     <div 
//                                         className="service-card" 
//                                         key={service.Id}
//                                         onClick={() => handleCardClick(service.services_name)}
//                                     >
//                                         <img src={`http://localhost:4001/uploads/${service.image}`} alt={service.services_name} />
//                                         <h3>{service.services_name}</h3>
//                                         <hr />
//                                         <p>{service.details}</p>
//                                     </div>
//                                 ))}
//                             </div>
//                             {/* {rowIndex < Math.ceil(services.length / 3) - 1 && <hr />} */}
//                         </React.Fragment>
//                     ))}
//                 </div>
//             </div>
//             <Footer />
//         </>
//     );
// }

// export default Home;

// ********* upper code, All okay and working fine last checked (17-6-25) *********** //





// ****** Added Translator EN-BN and updated (17-6-25) ****** //

// import React, { useState, useEffect, useCallback } from 'react';
// import { useNavigate } from 'react-router-dom';
// import './homeStyle.css';
// import Navbar from '../../Components/Navbar';
// import Footer from '../../Components/Footer/Footer';
// import Banner from '../../Assets/HELP.jpg';
// import axios from 'axios';
// import { useTranslation } from 'react-i18next';

// const Home = () => {
//   const { t, i18n } = useTranslation();
//   const [services, setServices] = useState([]);
//   const navigate = useNavigate();

//   const fetchServices = useCallback(async () => {
//     try {
//       const response = await axios.get('http://localhost:4001/services', {
//         params: { lang: i18n.language }
//       });
//       setServices(response.data);
//     } catch (error) {
//       console.error('Error fetching services:', error);
//     }
//   }, [i18n.language]);

//   useEffect(() => {
//     fetchServices();
//   }, [fetchServices]);

//   const handleCardClick = (serviceName) => {
//     const servicePath = serviceName.toLowerCase().replace(/\s+/g, '-');
//     navigate(`/services/${servicePath}`);
//   };

//   return (
//     <>
//       <Navbar />
//       <div className="home-content">
//         <div className="left-content">
//           <h1 dangerouslySetInnerHTML={{ __html: t('home.welcome') }} />
//           <p>{t('home.description')}</p>
//         </div>
//         <div className="right-content">
//           <img src={Banner} alt="" />
//         </div>
//       </div>

//       <div className="services">
//         <h2>{t('home.our_services')}</h2>
//         <div className="service-cards">
//           {Array.from({ length: Math.ceil(services.length / 3) }).map((_, rowIndex) => (
//             <React.Fragment key={rowIndex}>
//               <div className="service-card-row">
//                 {services.slice(rowIndex * 3, rowIndex * 3 + 3).map((service) => (
//                   <div
//                     className="service-card"
//                     key={service.Id}
//                     onClick={() => handleCardClick(service.services_name)}
//                   >
//                     <img src={`http://localhost:4001/uploads/${service.image}`} alt={service.services_name} />
//                     <h3>{service.services_name}</h3>
//                     <hr />
//                     <p>{service.details}</p>
//                   </div>
//                 ))}
//               </div>
//             </React.Fragment>
//           ))}
//         </div>
//       </div>
//       <Footer />
//     </>
//   );
// };

// export default Home;










// ***** Added new Translate service name and description from backend for Translate (18-6-25) ***** //

// import React, { useState, useEffect, useCallback } from "react";
// import { useNavigate } from "react-router-dom";
// import "./homeStyle.css";
// import Navbar from "../../Components/Navbar";
// import Footer from "../../Components/Footer/Footer";
// import Banner from "../../Assets/HELP.jpg";
// import axios from "axios";
// import { useTranslation } from "react-i18next";
// import FeedbackPage from "../Feedback/FeedbackPage";

// const Home = () => {
//   const { t, i18n } = useTranslation();
//   const [services, setServices] = useState([]);
//   const navigate = useNavigate();

//   const fetchServices = useCallback(async () => {
//     try {
//       const response = await axios.get("http://localhost:4001/services", {
//         params: { lang: i18n.language },
//       });
//       setServices(response.data);
//     } catch (error) {
//       console.error("Error fetching services:", error);
//     }
//   }, [i18n.language]);

//   useEffect(() => {
//     fetchServices();
//   }, [fetchServices]);

//   const handleCardClick = (serviceName) => {
//     const servicePath = serviceName.toLowerCase().replace(/\s+/g, "-");
//     navigate(`/services/${servicePath}`);
//   };

//   // added for backend service name translate
//   const getServiceKey = (serviceName) => {
//     return serviceName.trim().toLowerCase().replace(/\s+/g, "_");
//   };

//   return (
//     <>
//       <Navbar />
//       <div className="home-content">
//         <div className="left-content">
//           <h1 dangerouslySetInnerHTML={{ __html: t("home.welcome") }} />
//           <p>{t("home.description")}</p>
//         </div>
//         <div className="right-content">
//           <img src={Banner} alt="" />
//         </div>
//       </div>

//       <div className="services">
//         <h2>{t("home.our_services")}</h2>
//         <div className="service-cards">
//           {Array.from({ length: Math.ceil(services.length / 3) }).map(
//             (_, rowIndex) => (
//               <React.Fragment key={rowIndex}>
//                 <div className="service-card-row">
//                   {services
//                     .slice(rowIndex * 3, rowIndex * 3 + 3)
//                     .map((service) => {
//                       // CHANGE: Get translation key for the service
//                       const serviceKey = getServiceKey(service.services_name);
//                       // CHANGE: Use translated name and details
//                       const translatedName =
//                         i18n.language === "bn"
//                           ? t(`home.services.${serviceKey}.name`, {
//                               defaultValue: service.services_name,
//                             })
//                           : service.services_name;
//                       const translatedDetails =
//                         i18n.language === "bn"
//                           ? t(`home.services.${serviceKey}.details`, {
//                               defaultValue: service.details,
//                             })
//                           : service.details;

//                       return (
//                         <div
//                           className="service-card"
//                           key={service.Id}
//                           onClick={() => handleCardClick(service.services_name)}
//                         >
//                           <img
//                             src={`http://localhost:4001/uploads/${service.image}`}
//                             alt={service.services_name}
//                           />
//                           {/* <h3>{service.services_name}</h3> */}
//                           <h3>{translatedName}</h3>

//                           <hr />
//                           {/* <p>{service.details}</p> */}
//                           <p>{translatedDetails}</p>
//                         </div>
//                       );
//                     })}
//                 </div>
//               </React.Fragment>
//             )
//           )}
//         </div>
//       </div>
//       <FeedbackPage />
//       <Footer />
//     </>
//   );
// };

// export default Home;














// ***** New Updated With New Design (15-Sep-2025) ***** //

// import React, { useState, useEffect, useCallback, useRef } from "react";
// import { useNavigate } from "react-router-dom";
// import "./homeStyle.css";
// import Navbar from "../../Components/Navbar";
// import Footer from "../../Components/Footer/Footer";
// // import Banner from "../../Assets/HELP.jpg";
// import Banner from "../../Assets/BannerService.png";
// import AppStore from "../../Assets/Apple.png";
// import Playsore from "../../Assets/Google_Play_Store_badge.png";
// import axios from "axios";
// import { useTranslation } from "react-i18next";
// import FeedbackPage from "../Feedback/FeedbackPage";

// const Home = () => {
//   const { t, i18n } = useTranslation();
//   const [services, setServices] = useState([]);
//   const navigate = useNavigate();

//   // Coverage state
//   const [divisions, setDivisions] = useState([]);
//   const [areas, setAreas] = useState([]);
//   const [selectedCityId, setSelectedCityId] = useState("");

//   // Smooth scroll to Services
//   const servicesRef = useRef(null);

//   const fetchServices = useCallback(async () => {
//     try {
//       const response = await axios.get("http://localhost:4001/services", {
//         params: { lang: i18n.language },
//       });
//       setServices(response.data);
//     } catch (error) {
//       console.error("Error fetching services:", error);
//     }
//   }, [i18n.language]);

//   useEffect(() => {
//     fetchServices();
//   }, [fetchServices]);

//   // Load divisions (cities) on mount
//   useEffect(() => {
//     const loadDivisions = async () => {
//       try {
//         const { data } = await axios.get(
//           "http://localhost:4001/locations/divisions"
//         );
//         const list = Array.isArray(data) ? data : [];
//         setDivisions(list);

//         const preferredNames = ["Dhaka", "ঢাকা"];
//         const dhaka =
//           list.find((d) =>
//             preferredNames.some(
//               (n) => String(d.name || "").toLowerCase() === n.toLowerCase()
//             )
//           ) || list[0];

//         if (dhaka) {
//           setSelectedCityId(String(dhaka.Id));
//           await loadAreas(dhaka.Id);
//         }
//       } catch (e) {
//         console.error("Error loading divisions:", e);
//         setDivisions([]);
//       }
//     };
//     loadDivisions();
//   }, []);

//   // Load areas for a division
//   const loadAreas = async (divisionId) => {
//     if (!divisionId) {
//       setAreas([]);
//       return;
//     }
//     try {
//       const { data } = await axios.get(
//         "http://localhost:4001/locations/areas",
//         {
//           params: { divisionId },
//         }
//       );
//       setAreas(Array.isArray(data) ? data : []);
//     } catch (e) {
//       console.error("Error loading areas:", e);
//       setAreas([]);
//     }
//   };

//   const handleCardClick = (serviceName) => {
//     const servicePath = serviceName.toLowerCase().replace(/\s+/g, "-");
//     navigate(`/services/${servicePath}`);
//   };

//   const handleScrollToServices = () => {
//     if (servicesRef.current) {
//       servicesRef.current.scrollIntoView({
//         behavior: "smooth",
//         block: "start",
//       });
//     }
//   };

//   const goToServitorSignup = () => {
//     navigate("/earnwithHelpNao");
//   };

//   const getServiceKey = (serviceName) => {
//     return serviceName.trim().toLowerCase().replace(/\s+/g, "_");
//   };

//   // Service icon mapping
//   // const getServiceIcon = (serviceName) => {
//   //   const iconMap = {
//   //     electrician: "fas fa-bolt",
//   //     "home cleaning": "fas fa-broom",
//   //     plumber: "fas fa-toolbox",
//   //     "ac service": "fas fa-snowflake",
//   //     "filter": "fas fa-tint",
//   //     "gas chula": "fas fa-fire",
//   //     "tutor service": "fas fa-graduation-cap",
//   //   };
//   //   return iconMap[serviceName.toLowerCase()] || "fas fa-cog";
//   // };

//   return (
//     <>
//       <Navbar />

//       {/* HERO SECTION (spacing tightened below in CSS) */}
//       <section className="homepage-hero">
//         <div className="homepage-hero-container">
//           {/* Hero Visual - Mobile Top */}
//           <div className="homepage-hero-visual mobile-top">
//             <div className="homepage-floating-animation">
//               <div className="homepage-visual-outer">
//                 <div className="homepage-visual-middle">
//                   <div className="homepage-visual-inner">
//                     <i className="fas fa-handshake"></i>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Hero Content */}
//           <div className="homepage-hero-content">
//             <h1 dangerouslySetInnerHTML={{ __html: t("home.welcome") }} />
//             <p>{t("home.description")}</p>

//             <div className="homepage-hero-buttons">
//               <button
//                 className="homepage-btn-primary"
//                 onClick={handleScrollToServices}
//               >
//                 <i className="fas fa-search"></i>
//                 <span>
//                   {t("home.cta_book_service", {
//                     defaultValue: "Book a Service",
//                   })}
//                 </span>
//               </button>
//               <button
//                 className="homepage-btn-secondary"
//                 onClick={goToServitorSignup}
//               >
//                 <i className="fas fa-briefcase"></i>
//                 <span>
//                   {t("home.cta_become_servitor", {
//                     defaultValue: "Become a Provider",
//                   })}
//                 </span>
//               </button>
//             </div>
//           </div>

//           {/* Hero Visual - Desktop Right */}
//           <div className="homepage-hero-visual desktop-right">
//             <div className="homepage-floating-animation">
//               <div className="homepage-visual-outer">
//                 <div className="homepage-visual-middle">
//                   <div className="homepage-visual-inner">
//                     <i className="fas fa-handshake"></i>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* SERVICES SECTION */}
//       <section className="homepage-services" ref={servicesRef} id="services">
//         <div className="homepage-services-container">
//           <div className="homepage-services-header">
//             <h2>{t("home.our_services")}</h2>
//             {/* <p>From home maintenance to personal assistance, we've got you covered with trusted professionals</p> */}
//           </div>

//           {/* <div className="homepage-service-grid">
//             {services.map((service, index) => {
//               const serviceKey = getServiceKey(service.services_name);
//               const translatedName =
//                 i18n.language === "bn"
//                   ? t(`home.services.${serviceKey}.name`, {
//                       defaultValue: service.services_name,
//                     })
//                   : service.services_name;

//               return (
//                 <div
//                   className={`homepage-service-card service-${index + 1}`}
//                   key={service.Id}
//                   onClick={() => handleCardClick(service.services_name)}
//                 >
//                   <div className="homepage-service-icon">
//                     <i className={getServiceIcon(service.services_name)}></i>
//                   </div>
//                   <h3>{translatedName}</h3>
//                 </div>
//               );
//             })}
//           </div> */}


//           <div className="homepage-service-grid">
//             {services.map((service) => {
//               const serviceKey = getServiceKey(service.services_name);
//               const translatedName =
//                 i18n.language === "bn"
//                   ? t(`home.services.${serviceKey}.name`, {
//                       defaultValue: service.services_name,
//                     })
//                   : service.services_name;

//               return (
//                 <button
//                   type="button"
//                   className="service-tile"
//                   key={service.Id}
//                   onClick={() => handleCardClick(service.services_name)}
//                   aria-label={translatedName}
//                   title={translatedName}
//                 >
//                   <div className="service-thumb">
//                     <img
//                       src={`http://localhost:4001/uploads/${service.image}`}
//                       alt={translatedName}
//                       loading="lazy"
//                       draggable={false}
//                       onError={(e) => {
//                         // graceful fallback: hide broken img, show icon background
//                         e.currentTarget.style.display = "none";
//                         e.currentTarget.parentElement?.classList.add("fallback");
//                       }}
//                     />
//                     <i className="fas fa-cog fallback-icon" aria-hidden="true"></i>
//                   </div>
//                   <div className="service-name">{translatedName}</div>
//                 </button>
//               );
//             })}
//           </div>
//         </div>
//       </section>

//       {/* HOW IT WORKS */}
//       {/* <section className="homepage-howitworks" id="how-it-works">
//         <div className="homepage-howitworks-container">
//           <div className="homepage-howitworks-header">
//             <h2>
//               {t("home.hiw.title", { defaultValue: "How HelpNao Works" })}
//             </h2>
//             <p>
//               {t("home.hiw.subtitle", {
//                 defaultValue: "Simple steps to connect, serve, and earn",
//               })}
//             </p>
//           </div>
//           <div className="homepage-howitworks-block">
//             <h3 className="homepage-howitworks-subtitle seekers">
//               {t("home.hiw.seekers", { defaultValue: "For Service Seekers" })}
//             </h3>
//             <div className="homepage-howitworks-grid">
//               <div className="homepage-howitworks-card">
//                 <div className="homepage-howitworks-icon primary">
//                   <i className="fas fa-user-plus" />
//                 </div>
//                 <h4>1. {t("home.hiw.sign_up", { defaultValue: "Sign Up" })}</h4>
//                 <p>
//                   {t("home.hiw.sign_up_desc", {
//                     defaultValue:
//                       "Create your account and tell us about your needs",
//                   })}
//                 </p>
//               </div>
//               <div className="homepage-howitworks-card">
//                 <div className="homepage-howitworks-icon primary">
//                   <i className="fas fa-search" />
//                 </div>
//                 <h4>
//                   2.{" "}
//                   {t("home.hiw.browse", { defaultValue: "Browse Services" })}
//                 </h4>
//                 <p>
//                   {t("home.hiw.browse_desc", {
//                     defaultValue: "Explore our wide range of home services",
//                   })}
//                 </p>
//               </div>
//               <div className="homepage-howitworks-card">
//                 <div className="homepage-howitworks-icon primary">
//                   <i className="fas fa-calendar-check" />
//                 </div>
//                 <h4>
//                   3. {t("home.hiw.book", { defaultValue: "Book Service" })}
//                 </h4>
//                 <p>
//                   {t("home.hiw.book_desc", {
//                     defaultValue:
//                       "Place your order and schedule at your convenience",
//                   })}
//                 </p>
//               </div>
//               <div className="homepage-howitworks-card">
//                 <div className="homepage-howitworks-icon primary">
//                   <i className="fas fa-smile" />
//                 </div>
//                 <h4>4. {t("home.hiw.relax", { defaultValue: "Relax" })}</h4>
//                 <p>
//                   {t("home.hiw.relax_desc", {
//                     defaultValue:
//                       "Sit back while our verified professionals handle everything",
//                   })}
//                 </p>
//               </div>
//             </div>
//           </div>

//           <div className="homepage-howitworks-block">
//             <h3 className="homepage-howitworks-subtitle providers">
//               {t("home.hiw.providers", {
//                 defaultValue: "For Service Providers",
//               })}
//             </h3>
//             <div className="homepage-howitworks-highlight">
//               <h4>
//                 💰{" "}
//                 {t("home.hiw.earn_banner", {
//                   defaultValue: "Earn Up to ৳50,000+ Monthly",
//                 })}
//               </h4>
//               <p>
//                 {t("home.hiw.earn_desc", {
//                   defaultValue:
//                     "Join our platform and start earning with flexible working hours",
//                 })}
//               </p>
//             </div>
//             <div className="homepage-howitworks-grid">
//               <div className="homepage-howitworks-card">
//                 <div className="homepage-howitworks-icon secondary">
//                   <i className="fas fa-id-card" />
//                 </div>
//                 <h4>
//                   1. {t("home.hiw.register", { defaultValue: "Register" })}
//                 </h4>
//                 <p>
//                   {t("home.hiw.register_desc", {
//                     defaultValue: "Sign up and get verified with your skills",
//                   })}
//                 </p>
//               </div>
//               <div className="homepage-howitworks-card">
//                 <div className="homepage-howitworks-icon secondary">
//                   <i className="fas fa-bell" />
//                 </div>
//                 <h4>
//                   2. {t("home.hiw.requests", { defaultValue: "Get Requests" })}
//                 </h4>
//                 <p>
//                   {t("home.hiw.requests_desc", {
//                     defaultValue: "Receive service requests in your area",
//                   })}
//                 </p>
//               </div>
//               <div className="homepage-howitworks-card">
//                 <div className="homepage-howitworks-icon secondary">
//                   <i className="fas fa-tools" />
//                 </div>
//                 <h4>
//                   3.{" "}
//                   {t("home.hiw.provide", { defaultValue: "Provide Service" })}
//                 </h4>
//                 <p>
//                   {t("home.hiw.provide_desc", {
//                     defaultValue: "Deliver quality service to customers",
//                   })}
//                 </p>
//               </div>
//               <div className="homepage-howitworks-card">
//                 <div className="homepage-howitworks-icon secondary">
//                   <i className="fas fa-money-bill-wave" />
//                 </div>
//                 <h4>4. {t("home.hiw.earn", { defaultValue: "Earn Money" })}</h4>
//                 <p>
//                   {t("home.hiw.earn_desc", {
//                     defaultValue: "Get paid instantly for your excellent work",
//                   })}
//                 </p>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section> */}


//       {/* HOW TO START WITH HelpNao */}
//     <section className="homepage-howitworks" id="how-to-start">
//       <div className="homepage-howitworks-container">
//         <div className="homepage-howitworks-header">
//           <h2>
//             {t("home.start.title", { defaultValue: "How to Start with HelpNao" })}
//           </h2>
//           <p>
//             {t("home.start.subtitle", {
//               defaultValue: "Simple steps to get started on our platform",
//             })}
//           </p>
//         </div>

//         {/* Service Seekers Section */}
//         <div className="homepage-start-section">
//           <div className="homepage-start-grid">
//             {/* Left Column - Text Content */}
//             <div className="homepage-start-content seekers">
//               <div className="homepage-start-content-inner">
//                 <h3>
//                   {t("home.start.seeking_title", { defaultValue: "Searching For" })}{" "}
//                   <span className="highlight-blue">
//                     {t("home.start.services", { defaultValue: "Services?" })}
//                   </span>
//                 </h3>
//                 <p className="homepage-start-subtitle">
//                   {t("home.start.seeking_desc", {
//                     defaultValue: "How to place your order in just a few simple steps",
//                   })}
//                 </p>

//                 {/* Steps */}
//                 <div className="homepage-start-steps">
//                   <div className="homepage-start-step">
//                     <div className="homepage-start-step-number blue">1</div>
//                     <div className="homepage-start-step-content">
//                       <h4>
//                         {t("home.start.choose_service", {
//                           defaultValue: "Choose Your Service",
//                         })}
//                       </h4>
//                       <p>
//                         {t("home.start.choose_service_desc", {
//                           defaultValue: "Browse our categories and select the service you need",
//                         })}
//                       </p>
//                     </div>
//                   </div>
//                   <div className="homepage-start-step">
//                     <div className="homepage-start-step-number blue">2</div>
//                     <div className="homepage-start-step-content">
//                       <h4>
//                         {t("home.start.book_schedule", {
//                           defaultValue: "Book & Schedule",
//                         })}
//                       </h4>
//                       <p>
//                         {t("home.start.book_schedule_desc", {
//                           defaultValue: "Pick your preferred time and confirm your booking",
//                         })}
//                       </p>
//                     </div>
//                   </div>
//                   <div className="homepage-start-step">
//                     <div className="homepage-start-step-number blue">3</div>
//                     <div className="homepage-start-step-content">
//                       <h4>
//                         {t("home.start.enjoy_service", {
//                           defaultValue: "Enjoy Quality Service",
//                         })}
//                       </h4>
//                       <p>
//                         {t("home.start.enjoy_service_desc", {
//                           defaultValue: "Relax while our verified professionals take care of everything",
//                         })}
//                       </p>
//                     </div>
//                   </div>
//                 </div>

//                 <button className="homepage-start-btn blue">
//                   {t("home.start.start_booking", { defaultValue: "Start Booking Now" })}
//                 </button>
//               </div>
//             </div>

//             {/* Right Column - Illustration */}
//             <div className="homepage-start-visual seekers">
//               <div className="homepage-start-mockup">
//                 <div className="homepage-start-card">
//                   <div className="homepage-start-icon-large blue">
//                     <i className="fas fa-calendar-check"></i>
//                   </div>
//                   <h4>
//                     {t("home.start.easy_booking", { defaultValue: "Easy Booking" })}
//                   </h4>
//                   <p>
//                     {t("home.start.easy_booking_desc", {
//                       defaultValue: "Schedule services at your convenience",
//                     })}
//                   </p>

//                   {/* Mock service icons */}
//                   <div className="homepage-start-service-icons">
//                     <div className="homepage-start-service-icon">
//                       <i className="fas fa-bolt"></i>
//                     </div>
//                     <div className="homepage-start-service-icon">
//                       <i className="fas fa-broom"></i>
//                     </div>
//                     <div className="homepage-start-service-icon">
//                       <i className="fas fa-tools"></i>
//                     </div>
//                   </div>
//                 </div>
//                 <div className="homepage-start-bubble bubble-1"></div>
//               </div>
//             </div>
//           </div>
//         </div>


//          {/* Service Providers Section */}
//     {/* <div className="homepage-start-section">
//       <div className="homepage-start-grid providers">

//         <div className="homepage-start-visual providers">
//           <div className="homepage-start-mockup">
//             <div className="homepage-start-card">
//               <div className="homepage-start-icon-large green">
//                 <i className="fas fa-dollar-sign"></i>
//               </div>
//               <h4>
//                 {t("home.start.start_earning", { defaultValue: "Start Earning" })}
//               </h4>
//               <p>
//                 {t("home.start.start_earning_desc", {
//                   defaultValue: "Turn your skills into income",
//                 })}
//               </p>

//               <div className="homepage-start-earnings">
//                 <div className="homepage-start-earning-item">
//                   <span className="label">
//                     {t("home.start.this_month", { defaultValue: "This Month" })}
//                   </span>
//                   <span className="value">৳3,250</span>
//                 </div>
//                 <div className="homepage-start-earning-item">
//                   <span className="label">
//                     {t("home.start.jobs_completed", { defaultValue: "Jobs Completed" })}
//                   </span>
//                   <span className="value">47</span>
//                 </div>
//                 <div className="homepage-start-earning-item">
//                   <span className="label">
//                     {t("home.start.rating", { defaultValue: "Rating" })}
//                   </span>
//                   <span className="value">4.9 ⭐</span>
//                 </div>
//               </div>
//             </div>
//             <div className="homepage-start-bubble bubble-2"></div>
//           </div>
//         </div>

//         <div className="homepage-start-content providers">
//           <div className="homepage-start-content-inner">
//             <h3>
//               {t("home.start.want_earning", { defaultValue: "Want to Start" })}{" "}
//               <span className="highlight-green">
//                 {t("home.start.earning", { defaultValue: "Earning?" })}
//               </span>
//             </h3>
//             <p className="homepage-start-subtitle">
//               {t("home.start.want_earning_desc", {
//                 defaultValue: "Join our community of professional service providers",
//               })}
//             </p>
//             <p className="homepage-start-earning-highlight">
//               💰{" "}
//               {t("home.start.earn_amount", {
//                 defaultValue: "Earn up to ৳50,000+ Monthly",
//               })}
//             </p>

//             <div className="homepage-start-steps">
//               <div className="homepage-start-step">
//                 <div className="homepage-start-step-number green">1</div>
//                 <div className="homepage-start-step-content">
//                   <h4>
//                     {t("home.start.register_verify", {
//                       defaultValue: "Register & Verify",
//                     })}
//                   </h4>
//                   <p>
//                     {t("home.start.register_verify_desc", {
//                       defaultValue: "Sign up and complete our quick verification process",
//                     })}
//                   </p>
//                 </div>
//               </div>
//               <div className="homepage-start-step">
//                 <div className="homepage-start-step-number green">2</div>
//                 <div className="homepage-start-step-content">
//                   <h4>
//                     {t("home.start.get_requests", {
//                       defaultValue: "Get Job Requests",
//                     })}
//                   </h4>
//                   <p>
//                     {t("home.start.get_requests_desc", {
//                       defaultValue: "Receive service requests from customers in your area",
//                     })}
//                   </p>
//                 </div>
//               </div>
//               <div className="homepage-start-step">
//                 <div className="homepage-start-step-number green">3</div>
//                 <div className="homepage-start-step-content">
//                   <h4>
//                     {t("home.start.earn_grow", { defaultValue: "Earn & Grow" })}
//                   </h4>
//                   <p>
//                     {t("home.start.earn_grow_desc", {
//                       defaultValue: "Complete jobs, earn money, and build your reputation",
//                     })}
//                   </p>
//                 </div>
//               </div>
//             </div>

//             <button className="homepage-start-btn green">
//               {t("home.start.start_earning_today", {
//                 defaultValue: "Start Earning Today",
//               })}
//             </button>
//           </div>
//         </div>
//       </div>
//     </div> */}
//   </div>
// </section>


      

//       {/* COVERAGE SECTION */}
//       <section className="homepage-coverage" id="coverage">
//         <div className="homepage-coverage-container">
//           <div className="homepage-coverage-header">
//             <h2>
//               {t("home.coverage.title", {
//                 defaultValue: "We're available in your city",
//               })}
//             </h2>
//             <p>
//               {t("home.coverage.sub", {
//                 defaultValue:
//                   "Pick a city to see the active service areas we cover right now.",
//               })}
//             </p>
//           </div>

//           <div className="homepage-coverage-controls">
//             <div className="homepage-coverage-selector">
//               <label htmlFor="coverage-city">
//                 <i className="fas fa-city"></i>
//                 {t("home.coverage.city", { defaultValue: "City" })}
//               </label>
//               <select
//                 id="coverage-city"
//                 value={selectedCityId}
//                 onChange={async (e) => {
//                   const id = e.target.value;
//                   setSelectedCityId(id);
//                   setAreas([]);
//                   await loadAreas(id);
//                 }}
//               >
//                 {divisions.map((d) => (
//                   <option key={d.Id} value={String(d.Id)}>
//                     {d.name}
//                   </option>
//                 ))}
//               </select>
//               <div className="homepage-coverage-count">
//                 <i className="fas fa-map-pin"></i>
//                 {t("home.coverage.areas_count", {
//                   count: areas.length,
//                   defaultValue: `${areas.length} active areas`,
//                 })}
//               </div>
//             </div>
//           </div>

//           <div className="homepage-coverage-areas">
//             {areas.length === 0 ? (
//               <div className="homepage-coverage-empty">
//                 {t("home.coverage.empty", {
//                   defaultValue: "No active areas listed for this city yet.",
//                 })}
//               </div>
//             ) : (
//               areas.map((a) => (
//                 <div key={a.Id} className="homepage-coverage-chip">
//                   <i className="fas fa-map-marker-alt"></i>
//                   <span>{a.name}</span>
//                 </div>
//               ))
//             )}
//           </div>
//         </div>
//       </section>

//       {/* NEW: EARN MONEY SECTION (after coverage) */}
//             <section className="homepage-earn" id="earn-with-HelpNao"> {/* NEW */}
//               <div className="homepage-earn-container">
//                 <div className="homepage-earn-content">
//                   <h2>
//                     {t("home.earn.title", { defaultValue: "Earn money with your skills" })}
//                   </h2>
//                   <p>
//                     {t("home.earn.subtitle", {
//                       defaultValue:
//                         "Join thousands of professionals using HelpNao to find nearby jobs, manage bookings, and grow a steady income on your schedule.",
//                     })}
//                   </p>
//                   <button className="homepage-earn-btn" onClick={goToServitorSignup}>
//                     <i className="fas fa-rocket" aria-hidden="true"></i>
//                     <span>{t("home.earn.cta", { defaultValue: "Start Earning" })}</span>
//                   </button>
//                 </div>
//               </div>
      
//               {/* Full-width responsive banner */}
//               <div className="homepage-earn-banner full-bleed">
//                 <img
//                   src={Banner}
//                   alt={t("home.earn.banner_alt", { defaultValue: "Earn with HelpNao" })}
//                   loading="lazy"
//                   decoding="async"
//                 />
//               </div>
//             </section>

//       <FeedbackPage />

//       {/* MOBILE APP SECTION */}
//       <section className="homepage-app" id="app">
//         <div className="homepage-app-container">
//           <div className="homepage-app-grid">
//             <div className="homepage-app-content">
//               <h2>
//                 {t("home.app.title", { defaultValue: "Download Our Mobile App" })}
//               </h2>
//               <p>
//                 {t("home.app.subtitle", {
//                   defaultValue:
//                     "Get the full HelpNao experience on your phone. Book services, track providers, and manage your account on the go.",
//                 })}
//               </p>

//               <div className="homepage-store-buttons">
//                 <button
//                   type="button"
//                   className="homepage-store-btn"
//                   onClick={() =>
//                     window.open(
//                       "https://play.google.com/store/apps/details?id=your.app.id",
//                       "_blank"
//                     )
//                   }
//                 >
//                   <img src={Playsore} alt="Get it on Google Play" />
//                 </button>
//                 <div className="homepage-store-btn disabled">
//                   <img src={AppStore} alt="Download on the App Store" />
//                 </div>
//               </div>
//             </div>

//             <div className="homepage-app-mockup">
//               <div className="homepage-phone-wrapper">
//                 <div className="homepage-phone-bubble bubble-1"></div>
//                 <div className="homepage-phone-bubble bubble-2"></div>
//                 <div className="homepage-phone-bubble bubble-3"></div>

//                 <div className="homepage-phone">
//                   <div className="homepage-phone-notch"></div>
//                   <div className="homepage-phone-screen">
//                     <div className="homepage-phone-content">
//                       <i className="fas fa-mobile-alt"></i>
//                       <div className="homepage-phone-title">HelpNao</div>
//                       <div className="homepage-phone-subtitle">
//                         {t("home.app.card", { defaultValue: "App Preview" })}
//                       </div>
//                       <div className="homepage-phone-badge">
//                         {t("home.app.cardSoon", { defaultValue: "Coming Soon" })}
//                       </div>
//                     </div>
//                   </div>
//                   <div className="homepage-phone-homebar"></div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       <Footer />
//     </>
//   );
// };

// export default Home;












// ***** New Design Updated (16-Sep-2025) ***** //

// import React, { useState, useEffect, useCallback, useRef } from "react";
// import { useNavigate } from "react-router-dom";
// import "./homeStyle.css";
// import Navbar from "../../Components/Navbar";
// import Footer from "../../Components/Footer/Footer";
// // import Banner from "../../Assets/HELP.jpg";
// import Banner from "../../Assets/Helpnaeservice.png";
// import AppStore from "../../Assets/Apple.png";
// import Playsore from "../../Assets/Google_Play_Store_badge.png";
// import axios from "axios";
// import { useTranslation } from "react-i18next";
// import FeedbackPage from "../Feedback/FeedbackPage";

// const Home = () => {
//   const { t, i18n } = useTranslation();
//   const [services, setServices] = useState([]);
//   const navigate = useNavigate();

//   // Coverage state
//   const [divisions, setDivisions] = useState([]);
//   const [areas, setAreas] = useState([]);
//   const [selectedCityId, setSelectedCityId] = useState("");

//   // Smooth scroll to Services
//   const servicesRef = useRef(null);

//   const fetchServices = useCallback(async () => {
//     try {
//       const response = await axios.get("http://localhost:4001/services", {
//         params: { lang: i18n.language },
//       });
//       setServices(response.data);
//     } catch (error) {
//       console.error("Error fetching services:", error);
//     }
//   }, [i18n.language]);

//   useEffect(() => {
//     fetchServices();
//   }, [fetchServices]);

//   // Load divisions (cities) on mount
//   useEffect(() => {
//     const loadDivisions = async () => {
//       try {
//         const { data } = await axios.get(
//           "http://localhost:4001/locations/divisions"
//         );
//         const list = Array.isArray(data) ? data : [];
//         setDivisions(list);

//         const preferredNames = ["Dhaka", "ঢাকা"];
//         const dhaka =
//           list.find((d) =>
//             preferredNames.some(
//               (n) => String(d.name || "").toLowerCase() === n.toLowerCase()
//             )
//           ) || list[0];

//         if (dhaka) {
//           setSelectedCityId(String(dhaka.Id));
//           await loadAreas(dhaka.Id);
//         }
//       } catch (e) {
//         console.error("Error loading divisions:", e);
//         setDivisions([]);
//       }
//     };
//     loadDivisions();
//   }, []);

//   // Load areas for a division
//   const loadAreas = async (divisionId) => {
//     if (!divisionId) {
//       setAreas([]);
//       return;
//     }
//     try {
//       const { data } = await axios.get(
//         "http://localhost:4001/locations/areas",
//         {
//           params: { divisionId },
//         }
//       );
//       setAreas(Array.isArray(data) ? data : []);
//     } catch (e) {
//       console.error("Error loading areas:", e);
//       setAreas([]);
//     }
//   };

//   const handleCardClick = (serviceName) => {
//     const servicePath = serviceName.toLowerCase().replace(/\s+/g, "-");
//     navigate(`/services/${servicePath}`);
//   };

//   const handleScrollToServices = () => {
//     if (servicesRef.current) {
//       servicesRef.current.scrollIntoView({
//         behavior: "smooth",
//         block: "start",
//       });
//     }
//   };

//   const goToServitorSignup = () => {
//     navigate("/earnwithHelpNao");
//   };

//   const getServiceKey = (serviceName) => {
//     return serviceName.trim().toLowerCase().replace(/\s+/g, "_");
//   };

//   // Service icon mapping
//   // const getServiceIcon = (serviceName) => {
//   //   const iconMap = {
//   //     electrician: "fas fa-bolt",
//   //     "home cleaning": "fas fa-broom",
//   //     plumber: "fas fa-toolbox",
//   //     "ac service": "fas fa-snowflake",
//   //     "filter": "fas fa-tint",
//   //     "gas chula": "fas fa-fire",
//   //     "tutor service": "fas fa-graduation-cap",
//   //   };
//   //   return iconMap[serviceName.toLowerCase()] || "fas fa-cog";
//   // };

//   return (
//     <>
//       <Navbar />

//       {/* HERO SECTION (spacing tightened below in CSS) */}
//       <section className="homepage-hero">
//         <div className="homepage-hero-container">
//           {/* Hero Visual - Mobile Top */}
//           <div className="homepage-hero-visual mobile-top">
//             <div className="homepage-floating-animation">
//               <div className="homepage-visual-outer">
//                 <div className="homepage-visual-middle">
//                   <div className="homepage-visual-inner">
//                     <i className="fas fa-handshake"></i>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Hero Content */}
//           <div className="homepage-hero-content">
//             <h1 dangerouslySetInnerHTML={{ __html: t("home.welcome") }} />
//             <p>{t("home.description")}</p>

//             <div className="homepage-hero-buttons">
//               <button
//                 className="homepage-btn-primary"
//                 onClick={handleScrollToServices}
//               >
//                 <i className="fas fa-search"></i>
//                 <span>
//                   {t("home.cta_book_service", {
//                     defaultValue: "Book a Service",
//                   })}
//                 </span>
//               </button>
//               <button
//                 className="homepage-btn-secondary"
//                 onClick={goToServitorSignup}
//               >
//                 <i className="fas fa-briefcase"></i>
//                 <span>
//                   {t("home.cta_become_servitor", {
//                     defaultValue: "Become a Provider",
//                   })}
//                 </span>
//               </button>
//             </div>
//           </div>

//           {/* Hero Visual - Desktop Right */}
//           <div className="homepage-hero-visual desktop-right">
//             <div className="homepage-floating-animation">
//               <div className="homepage-visual-outer">
//                 <div className="homepage-visual-middle">
//                   <div className="homepage-visual-inner">
//                     <i className="fas fa-handshake"></i>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* SERVICES SECTION */}
//       <section className="homepage-services" ref={servicesRef} id="services">
//         <div className="homepage-services-container">
//           <div className="homepage-services-header">
//             <h2>{t("home.our_services")}</h2>
//             {/* <p>From home maintenance to personal assistance, we've got you covered with trusted professionals</p> */}
//           </div>

//           {/* <div className="homepage-service-grid">
//             {services.map((service, index) => {
//               const serviceKey = getServiceKey(service.services_name);
//               const translatedName =
//                 i18n.language === "bn"
//                   ? t(`home.services.${serviceKey}.name`, {
//                       defaultValue: service.services_name,
//                     })
//                   : service.services_name;

//               return (
//                 <div
//                   className={`homepage-service-card service-${index + 1}`}
//                   key={service.Id}
//                   onClick={() => handleCardClick(service.services_name)}
//                 >
//                   <div className="homepage-service-icon">
//                     <i className={getServiceIcon(service.services_name)}></i>
//                   </div>
//                   <h3>{translatedName}</h3>
//                 </div>
//               );
//             })}
//           </div> */}

//           <div className="homepage-service-grid">
//             {services.map((service) => {
//               const serviceKey = getServiceKey(service.services_name);
//               const translatedName =
//                 i18n.language === "bn"
//                   ? t(`home.services.${serviceKey}.name`, {
//                       defaultValue: service.services_name,
//                     })
//                   : service.services_name;

//               return (
//                 <button
//                   type="button"
//                   className="service-tile"
//                   key={service.Id}
//                   onClick={() => handleCardClick(service.services_name)}
//                   aria-label={translatedName}
//                   title={translatedName}
//                 >
//                   <div className="service-thumb">
//                     <img
//                       src={`http://localhost:4001/uploads/${service.image}`}
//                       alt={translatedName}
//                       loading="lazy"
//                       draggable={false}
//                       onError={(e) => {
//                         // graceful fallback: hide broken img, show icon background
//                         e.currentTarget.style.display = "none";
//                         e.currentTarget.parentElement?.classList.add(
//                           "fallback"
//                         );
//                       }}
//                     />
//                     <i
//                       className="fas fa-cog fallback-icon"
//                       aria-hidden="true"
//                     ></i>
//                   </div>
//                   <div className="service-name">{translatedName}</div>
//                 </button>
//               );
//             })}
//           </div>
//         </div>
//       </section>

//       {/* HOW IT WORKS */}
//       {/* <section className="homepage-howitworks" id="how-it-works">
//         <div className="homepage-howitworks-container">
//           <div className="homepage-howitworks-header">
//             <h2>
//               {t("home.hiw.title", { defaultValue: "How HelpNao Works" })}
//             </h2>
//             <p>
//               {t("home.hiw.subtitle", {
//                 defaultValue: "Simple steps to connect, serve, and earn",
//               })}
//             </p>
//           </div>
//           <div className="homepage-howitworks-block">
//             <h3 className="homepage-howitworks-subtitle seekers">
//               {t("home.hiw.seekers", { defaultValue: "For Service Seekers" })}
//             </h3>
//             <div className="homepage-howitworks-grid">
//               <div className="homepage-howitworks-card">
//                 <div className="homepage-howitworks-icon primary">
//                   <i className="fas fa-user-plus" />
//                 </div>
//                 <h4>1. {t("home.hiw.sign_up", { defaultValue: "Sign Up" })}</h4>
//                 <p>
//                   {t("home.hiw.sign_up_desc", {
//                     defaultValue:
//                       "Create your account and tell us about your needs",
//                   })}
//                 </p>
//               </div>
//               <div className="homepage-howitworks-card">
//                 <div className="homepage-howitworks-icon primary">
//                   <i className="fas fa-search" />
//                 </div>
//                 <h4>
//                   2.{" "}
//                   {t("home.hiw.browse", { defaultValue: "Browse Services" })}
//                 </h4>
//                 <p>
//                   {t("home.hiw.browse_desc", {
//                     defaultValue: "Explore our wide range of home services",
//                   })}
//                 </p>
//               </div>
//               <div className="homepage-howitworks-card">
//                 <div className="homepage-howitworks-icon primary">
//                   <i className="fas fa-calendar-check" />
//                 </div>
//                 <h4>
//                   3. {t("home.hiw.book", { defaultValue: "Book Service" })}
//                 </h4>
//                 <p>
//                   {t("home.hiw.book_desc", {
//                     defaultValue:
//                       "Place your order and schedule at your convenience",
//                   })}
//                 </p>
//               </div>
//               <div className="homepage-howitworks-card">
//                 <div className="homepage-howitworks-icon primary">
//                   <i className="fas fa-smile" />
//                 </div>
//                 <h4>4. {t("home.hiw.relax", { defaultValue: "Relax" })}</h4>
//                 <p>
//                   {t("home.hiw.relax_desc", {
//                     defaultValue:
//                       "Sit back while our verified professionals handle everything",
//                   })}
//                 </p>
//               </div>
//             </div>
//           </div>

//           <div className="homepage-howitworks-block">
//             <h3 className="homepage-howitworks-subtitle providers">
//               {t("home.hiw.providers", {
//                 defaultValue: "For Service Providers",
//               })}
//             </h3>
//             <div className="homepage-howitworks-highlight">
//               <h4>
//                 💰{" "}
//                 {t("home.hiw.earn_banner", {
//                   defaultValue: "Earn Up to ৳50,000+ Monthly",
//                 })}
//               </h4>
//               <p>
//                 {t("home.hiw.earn_desc", {
//                   defaultValue:
//                     "Join our platform and start earning with flexible working hours",
//                 })}
//               </p>
//             </div>
//             <div className="homepage-howitworks-grid">
//               <div className="homepage-howitworks-card">
//                 <div className="homepage-howitworks-icon secondary">
//                   <i className="fas fa-id-card" />
//                 </div>
//                 <h4>
//                   1. {t("home.hiw.register", { defaultValue: "Register" })}
//                 </h4>
//                 <p>
//                   {t("home.hiw.register_desc", {
//                     defaultValue: "Sign up and get verified with your skills",
//                   })}
//                 </p>
//               </div>
//               <div className="homepage-howitworks-card">
//                 <div className="homepage-howitworks-icon secondary">
//                   <i className="fas fa-bell" />
//                 </div>
//                 <h4>
//                   2. {t("home.hiw.requests", { defaultValue: "Get Requests" })}
//                 </h4>
//                 <p>
//                   {t("home.hiw.requests_desc", {
//                     defaultValue: "Receive service requests in your area",
//                   })}
//                 </p>
//               </div>
//               <div className="homepage-howitworks-card">
//                 <div className="homepage-howitworks-icon secondary">
//                   <i className="fas fa-tools" />
//                 </div>
//                 <h4>
//                   3.{" "}
//                   {t("home.hiw.provide", { defaultValue: "Provide Service" })}
//                 </h4>
//                 <p>
//                   {t("home.hiw.provide_desc", {
//                     defaultValue: "Deliver quality service to customers",
//                   })}
//                 </p>
//               </div>
//               <div className="homepage-howitworks-card">
//                 <div className="homepage-howitworks-icon secondary">
//                   <i className="fas fa-money-bill-wave" />
//                 </div>
//                 <h4>4. {t("home.hiw.earn", { defaultValue: "Earn Money" })}</h4>
//                 <p>
//                   {t("home.hiw.earn_desc", {
//                     defaultValue: "Get paid instantly for your excellent work",
//                   })}
//                 </p>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section> */}

//       {/* HOW TO START WITH HelpNao */}
//       <section className="homepage-howitworks" id="how-to-start">
//         <div className="homepage-howitworks-container">
//           <div className="homepage-howitworks-header">
//             <h2>
//               {t("home.start.title", {
//                 defaultValue: "How to Start with HelpNao",
//               })}
//             </h2>
//             <p>
//               {t("home.start.subtitle", {
//                 defaultValue: "Simple steps to get started on our platform",
//               })}
//             </p>
//           </div>

//           {/* Service Seekers Section */}
//           <div className="homepage-start-section">
//             <div className="homepage-start-grid">
//               {/* Left Column - Text Content */}
//               <div className="homepage-start-content seekers">
//                 <div className="homepage-start-content-inner">
//                   <h3>
//                     {t("home.start.seeking_title", {
//                       defaultValue: "Searching For",
//                     })}{" "}
//                     <span className="highlight-blue">
//                       {t("home.start.services", { defaultValue: "Services?" })}
//                     </span>
//                   </h3>
//                   <p className="homepage-start-subtitle">
//                     {t("home.start.seeking_desc", {
//                       defaultValue:
//                         "How to place your order in just a few simple steps",
//                     })}
//                   </p>

//                   {/* Steps */}
//                   <div className="homepage-start-steps">
//                     <div className="homepage-start-step">
//                       <div className="homepage-start-step-number blue">1</div>
//                       <div className="homepage-start-step-content">
//                         <h4>
//                           {t("home.start.choose_service", {
//                             defaultValue: "Log in & Choose Your Service",
//                           })}
//                         </h4>
//                         <p>
//                           {t("home.start.choose_service_desc", {
//                             defaultValue:
//                               "Browse our categories and select the service you need",
//                           })}
//                         </p>
//                       </div>
//                     </div>
//                     <div className="homepage-start-step">
//                       <div className="homepage-start-step-number blue">2</div>
//                       <div className="homepage-start-step-content">
//                         <h4>
//                           {t("home.start.book_schedule", {
//                             defaultValue: "Book & Schedule",
//                           })}
//                         </h4>
//                         <p>
//                           {t("home.start.book_schedule_desc", {
//                             defaultValue:
//                               "Pick your preferred time and confirm your booking",
//                           })}
//                         </p>
//                       </div>
//                     </div>
//                     <div className="homepage-start-step">
//                       <div className="homepage-start-step-number blue">3</div>
//                       <div className="homepage-start-step-content">
//                         <h4>
//                           {t("home.start.enjoy_service", {
//                             defaultValue: "Enjoy Quality Service",
//                           })}
//                         </h4>
//                         <p>
//                           {t("home.start.enjoy_service_desc", {
//                             defaultValue:
//                               "Relax while our verified professionals take care of everything",
//                           })}
//                         </p>
//                       </div>
//                     </div>
//                   </div>

//                   <button className="homepage-start-btn blue">
//                     {t("home.start.start_booking", {
//                       defaultValue: "Start Booking Now",
//                     })}
//                   </button>
//                 </div>
//               </div>

//               {/* Right Column - Illustration */}
//               <div className="homepage-start-visual seekers">
//                 <div className="homepage-start-mockup">
//                   <div className="homepage-start-card">
//                     <div className="homepage-start-icon-large blue">
//                       <i className="fas fa-calendar-check"></i>
//                     </div>
//                     <h4>
//                       {t("home.start.easy_booking", {
//                         defaultValue: "Easy Booking",
//                       })}
//                     </h4>
//                     <p>
//                       {t("home.start.easy_booking_desc", {
//                         defaultValue: "Schedule services at your convenience",
//                       })}
//                     </p>

//                     {/* Mock service icons */}
//                     <div className="homepage-start-service-icons">
//                       <div className="homepage-start-service-icon">
//                         <i className="fas fa-bolt"></i>
//                       </div>
//                       <div className="homepage-start-service-icon">
//                         <i className="fas fa-broom"></i>
//                       </div>
//                       <div className="homepage-start-service-icon">
//                         <i className="fas fa-tools"></i>
//                       </div>
//                     </div>
//                   </div>
//                   <div className="homepage-start-bubble bubble-1"></div>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Service Providers Section */}
//           {/* <div className="homepage-start-section">
//       <div className="homepage-start-grid providers">

//         <div className="homepage-start-visual providers">
//           <div className="homepage-start-mockup">
//             <div className="homepage-start-card">
//               <div className="homepage-start-icon-large green">
//                 <i className="fas fa-dollar-sign"></i>
//               </div>
//               <h4>
//                 {t("home.start.start_earning", { defaultValue: "Start Earning" })}
//               </h4>
//               <p>
//                 {t("home.start.start_earning_desc", {
//                   defaultValue: "Turn your skills into income",
//                 })}
//               </p>

//               <div className="homepage-start-earnings">
//                 <div className="homepage-start-earning-item">
//                   <span className="label">
//                     {t("home.start.this_month", { defaultValue: "This Month" })}
//                   </span>
//                   <span className="value">৳3,250</span>
//                 </div>
//                 <div className="homepage-start-earning-item">
//                   <span className="label">
//                     {t("home.start.jobs_completed", { defaultValue: "Jobs Completed" })}
//                   </span>
//                   <span className="value">47</span>
//                 </div>
//                 <div className="homepage-start-earning-item">
//                   <span className="label">
//                     {t("home.start.rating", { defaultValue: "Rating" })}
//                   </span>
//                   <span className="value">4.9 ⭐</span>
//                 </div>
//               </div>
//             </div>
//             <div className="homepage-start-bubble bubble-2"></div>
//           </div>
//         </div>

//         <div className="homepage-start-content providers">
//           <div className="homepage-start-content-inner">
//             <h3>
//               {t("home.start.want_earning", { defaultValue: "Want to Start" })}{" "}
//               <span className="highlight-green">
//                 {t("home.start.earning", { defaultValue: "Earning?" })}
//               </span>
//             </h3>
//             <p className="homepage-start-subtitle">
//               {t("home.start.want_earning_desc", {
//                 defaultValue: "Join our community of professional service providers",
//               })}
//             </p>
//             <p className="homepage-start-earning-highlight">
//               💰{" "}
//               {t("home.start.earn_amount", {
//                 defaultValue: "Earn up to ৳50,000+ Monthly",
//               })}
//             </p>

//             <div className="homepage-start-steps">
//               <div className="homepage-start-step">
//                 <div className="homepage-start-step-number green">1</div>
//                 <div className="homepage-start-step-content">
//                   <h4>
//                     {t("home.start.register_verify", {
//                       defaultValue: "Register & Verify",
//                     })}
//                   </h4>
//                   <p>
//                     {t("home.start.register_verify_desc", {
//                       defaultValue: "Sign up and complete our quick verification process",
//                     })}
//                   </p>
//                 </div>
//               </div>
//               <div className="homepage-start-step">
//                 <div className="homepage-start-step-number green">2</div>
//                 <div className="homepage-start-step-content">
//                   <h4>
//                     {t("home.start.get_requests", {
//                       defaultValue: "Get Job Requests",
//                     })}
//                   </h4>
//                   <p>
//                     {t("home.start.get_requests_desc", {
//                       defaultValue: "Receive service requests from customers in your area",
//                     })}
//                   </p>
//                 </div>
//               </div>
//               <div className="homepage-start-step">
//                 <div className="homepage-start-step-number green">3</div>
//                 <div className="homepage-start-step-content">
//                   <h4>
//                     {t("home.start.earn_grow", { defaultValue: "Earn & Grow" })}
//                   </h4>
//                   <p>
//                     {t("home.start.earn_grow_desc", {
//                       defaultValue: "Complete jobs, earn money, and build your reputation",
//                     })}
//                   </p>
//                 </div>
//               </div>
//             </div>

//             <button className="homepage-start-btn green">
//               {t("home.start.start_earning_today", {
//                 defaultValue: "Start Earning Today",
//               })}
//             </button>
//           </div>
//         </div>
//       </div>
//     </div> */}
//         </div>
//       </section>

//       {/* COVERAGE SECTION */}
//       <section className="homepage-coverage" id="coverage">
//         <div className="homepage-coverage-container">
//           <div className="homepage-coverage-header">
//             <h2>
//               {t("home.coverage.title", {
//                 defaultValue: "We're available in your city",
//               })}
//             </h2>
//             <p>
//               {t("home.coverage.sub", {
//                 defaultValue:
//                   "Pick a city to see the active service areas we cover right now.",
//               })}
//             </p>
//           </div>

//           <div className="homepage-coverage-controls">
//             <div className="homepage-coverage-selector">
//               <label htmlFor="coverage-city">
//                 <i className="fas fa-city"></i>
//                 {t("home.coverage.city", { defaultValue: "City" })}
//               </label>
//               <select
//                 id="coverage-city"
//                 value={selectedCityId}
//                 onChange={async (e) => {
//                   const id = e.target.value;
//                   setSelectedCityId(id);
//                   setAreas([]);
//                   await loadAreas(id);
//                 }}
//               >
//                 {divisions.map((d) => (
//                   <option key={d.Id} value={String(d.Id)}>
//                     {d.name}
//                   </option>
//                 ))}
//               </select>
//               <div className="homepage-coverage-count">
//                 <i className="fas fa-map-pin"></i>
//                 {t("home.coverage.areas_count", {
//                   count: areas.length,
//                   defaultValue: `${areas.length} active areas`,
//                 })}
//               </div>
//             </div>
//           </div>

//           <div className="homepage-coverage-areas">
//             {areas.length === 0 ? (
//               <div className="homepage-coverage-empty">
//                 {t("home.coverage.empty", {
//                   defaultValue: "No active areas listed for this city yet.",
//                 })}
//               </div>
//             ) : (
//               areas.map((a) => (
//                 <div key={a.Id} className="homepage-coverage-chip">
//                   <i className="fas fa-map-marker-alt"></i>
//                   <span>{a.name}</span>
//                 </div>
//               ))
//             )}
//           </div>
//         </div>
//       </section>

//       {/* NEW: EARN MONEY SECTION (after coverage) */}
//       <section className="homepage-earn" id="earn-with-HelpNao">
//         {" "}
//         {/* NEW */}
//         <div className="homepage-earn-container">
//           <div className="homepage-earn-content">
//             <h2>
//               {t("home.earn.title", {
//                 defaultValue: "Earn money with your skills",
//               })}
//             </h2>
//             <p>
//               {t("home.earn.subtitle", {
//                 defaultValue:
//                   "Join thousands of professionals using HelpNao to find nearby jobs, manage bookings, and grow a steady income on your schedule.",
//               })}
//             </p>
//             <button className="homepage-earn-btn" onClick={goToServitorSignup}>
//               <i className="fas fa-rocket" aria-hidden="true"></i>
//               <span>
//                 {t("home.earn.cta", { defaultValue: "Start Earning" })}
//               </span>
//             </button>
//           </div>
//         </div>
//         {/* Full-width responsive banner */}
//         <div className="homepage-earn-banner full-bleed">
//           <img
//             src={Banner}
//             alt={t("home.earn.banner_alt", {
//               defaultValue: "Earn with HelpNao",
//             })}
//             loading="lazy"
//             decoding="async"
//           />
//         </div>
//       </section>

//       <FeedbackPage />

//       {/* MOBILE APP SECTION */}
//       <section className="homepage-app" id="app">
//         <div className="homepage-app-container">
//           <div className="homepage-app-grid">
//             <div className="homepage-app-content">
//               <h2>
//                 {t("home.app.title", {
//                   defaultValue: "Download Our Mobile App",
//                 })}
//               </h2>
//               <p>
//                 {t("home.app.subtitle", {
//                   defaultValue:
//                     "Get the full HelpNao experience on your phone. Book services, track providers, and manage your account on the go.",
//                 })}
//               </p>

//               <div className="homepage-store-buttons">
//                 <button
//                   type="button"
//                   className="homepage-store-btn"
//                   onClick={() =>
//                     window.open(
//                       "https://play.google.com/store/apps/details?id=your.app.id",
//                       "_blank"
//                     )
//                   }
//                 >
//                   <img src={Playsore} alt="Get it on Google Play" />
//                 </button>
//                 <div className="homepage-store-btn disabled">
//                   <img src={AppStore} alt="Download on the App Store" />
//                 </div>
//               </div>
//             </div>

//             <div className="homepage-app-mockup">
//               <div className="homepage-phone-wrapper">
//                 <div className="homepage-phone-bubble bubble-1"></div>
//                 <div className="homepage-phone-bubble bubble-2"></div>
//                 <div className="homepage-phone-bubble bubble-3"></div>

//                 <div className="homepage-phone">
//                   <div className="homepage-phone-notch"></div>
//                   <div className="homepage-phone-screen">
//                     <div className="homepage-phone-content">
//                       <i className="fas fa-mobile-alt"></i>
//                       <div className="homepage-phone-title">HelpNao</div>
//                       <div className="homepage-phone-subtitle">
//                         {t("home.app.card", { defaultValue: "App Preview" })}
//                       </div>
//                       <div className="homepage-phone-badge">
//                         {t("home.app.cardSoon", {
//                           defaultValue: "Coming Soon",
//                         })}
//                       </div>
//                     </div>
//                   </div>
//                   <div className="homepage-phone-homebar"></div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       <Footer />
//     </>
//   );
// };

// export default Home;





// ***** Add URL and Updated (13-Oct-2025) ***** //

// import React, { useState, useEffect, useCallback, useRef } from "react";
// import { useNavigate } from "react-router-dom";
// import "./homeStyle.css";
// import Navbar from "../../Components/Navbar";
// import Footer from "../../Components/Footer/Footer";
// // import Banner from "../../Assets/HELP.jpg";
// // import Banner from "../../Assets/Helpnaeservice.png";
// import Banner from "../../Assets/HelpNao-Banner-Starearning.png";
// // import AppStore from "../../Assets/Apple.png";
// // import Playsore from "../../Assets/Google_Play_Store_badge.png";
// import axios from "axios";
// import { useTranslation } from "react-i18next";
// import FeedbackPage from "../Feedback/FeedbackPage";
// import { URL } from "../../config";
// import Loader from "../../Components/LoaderSpin/Loader";

// const Home = () => {
//   const { t, i18n } = useTranslation();
//   const [services, setServices] = useState([]);
//   const navigate = useNavigate();

//   // Coverage state
//   const [divisions, setDivisions] = useState([]);
//   const [areas, setAreas] = useState([]);
//   const [selectedCityId, setSelectedCityId] = useState("");

//   // For loader
//   const [loadingServices, setLoadingServices] = useState(true);
//   const [loadingDivisions, setLoadingDivisions] = useState(true);
//   const [loadingAreas, setLoadingAreas] = useState(true);

//   const [showScrollTop, setShowScrollTop] = useState(false);


//   // Smooth scroll to Services
//   const servicesRef = useRef(null);

//   const showLoader = loadingServices || loadingDivisions || loadingAreas;

//   const fetchServices = useCallback(async () => {
//     setLoadingServices(true);
//     try {
//       const response = await axios.get(`${URL}/services`, {
//         params: { lang: i18n.language },
//       });
//       setServices(response.data);
//     } catch (error) {
//       console.error("Error fetching services:", error);
//     } finally {
//     setLoadingServices(false);
//   }
//   }, [i18n.language]);

//   useEffect(() => {
//     fetchServices();
//   }, [fetchServices]);

//   // Load divisions (cities) on mount
//   useEffect(() => {
//     const loadDivisions = async () => {
//       setLoadingDivisions(true);
//       try {
//         const { data } = await axios.get(
//           `${URL}/locations/divisions`
//         );
//         const list = Array.isArray(data) ? data : [];
//         setDivisions(list);

//         const preferredNames = ["Dhaka", "ঢাকা"];
//         const dhaka =
//           list.find((d) =>
//             preferredNames.some(
//               (n) => String(d.name || "").toLowerCase() === n.toLowerCase()
//             )
//           ) || list[0];

//         if (dhaka) {
//           setSelectedCityId(String(dhaka.Id));
//           await loadAreas(dhaka.Id);
//         }
//       } catch (e) {
//         console.error("Error loading divisions:", e);
//         setDivisions([]);
//       }
//       finally {
//       setLoadingDivisions(false);
//     }
//     };
//     loadDivisions();
//   }, []);

//   // Load areas for a division
//   const loadAreas = async (divisionId) => {
//     if (!divisionId) {
//       setAreas([]);
//       return;
//     }
//     setLoadingAreas(true);
//     try {
//       const { data } = await axios.get(
//         `${URL}/locations/areas`,
//         {
//           params: { divisionId },
//         }
//       );
//       setAreas(Array.isArray(data) ? data : []);
//     } catch (e) {
//       console.error("Error loading areas:", e);
//       setAreas([]);
//     } finally {
//     setLoadingAreas(false);
//   }
//   };


//   useEffect(() => {
//     let ticking = false;

//     const onScroll = () => {
//       if (!ticking) {
//         window.requestAnimationFrame(() => {
//           setShowScrollTop(window.scrollY > 320);
//           ticking = false;
//         });
//         ticking = true;
//       }
//     };

//     window.addEventListener("scroll", onScroll, { passive: true });
//     onScroll(); // run once on mount
//     return () => window.removeEventListener("scroll", onScroll);
//   }, []);

//   // NEW: smooth scroll to top
//   const scrollToTop = () => {
//     window.scrollTo({ top: 0, behavior: "smooth" });
//   };



//   const handleCardClick = (serviceName) => {
//     const servicePath = serviceName.toLowerCase().replace(/\s+/g, "-");
//     navigate(`/services/${servicePath}`);
//   };

//   const handleScrollToServices = () => {
//     if (servicesRef.current) {
//       servicesRef.current.scrollIntoView({
//         behavior: "smooth",
//         block: "start",
//       });
//     }
//   };

//   const goToServitorSignup = () => {
//     navigate("/earnwithHelpNao");
//   };

//   const getServiceKey = (serviceName) => {
//     return serviceName.trim().toLowerCase().replace(/\s+/g, "_");
//   };

//   // Service icon mapping
//   // const getServiceIcon = (serviceName) => {
//   //   const iconMap = {
//   //     electrician: "fas fa-bolt",
//   //     "home cleaning": "fas fa-broom",
//   //     plumber: "fas fa-toolbox",
//   //     "ac service": "fas fa-snowflake",
//   //     "filter": "fas fa-tint",
//   //     "gas chula": "fas fa-fire",
//   //     "tutor service": "fas fa-graduation-cap",
//   //   };
//   //   return iconMap[serviceName.toLowerCase()] || "fas fa-cog";
//   // };

//   return (
//     <>
//   {/* For loader */}
//     <Loader
//       show={showLoader}
//       brand="HelpNao"
//       message={t("home.loaderMessage", {
//         defaultValue: "Connecting you with trusted service providers...",
//       })}
//     />
//       <Navbar />

//       {/* HERO SECTION (spacing tightened below in CSS) */}
//       <section className="homepage-hero">
//         <div className="homepage-hero-container">
//           {/* Hero Visual - Mobile Top */}

//           {/* <div className="homepage-hero-visual mobile-top">
//             <div className="homepage-floating-animation">
//               <div className="homepage-visual-outer">
//                 <div className="homepage-visual-middle">
//                   <div className="homepage-visual-inner">
//                     <i className="fas fa-handshake"></i>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div> */}

//           <div className="homepage-hero-visual mobile-top">
//             <div className="homepage-floating-animation">
//               <div className="homepage-hero-poster">
//                 <img
//                   src={require("../../Assets/HelpNao-Hero_img.png")}
//                   alt="HelpNao Hero Poster"
//                   className="homepage-hero-image"
//                 />
//               </div>
//             </div>
//           </div>

//           {/* Hero Content */}
//           <div className="homepage-hero-content">
//             <h1 dangerouslySetInnerHTML={{ __html: t("home.welcome") }} />
//             <p>{t("home.description")}</p>

//             <div className="homepage-hero-buttons">
//               <button
//                 className="homepage-btn-primary"
//                 onClick={handleScrollToServices}
//               >
//                 <i className="fas fa-search"></i>
//                 <span>
//                   {t("home.cta_book_service", {
//                     defaultValue: "Book a Service",
//                   })}
//                 </span>
//               </button>
//               <button
//                 className="homepage-btn-secondary"
//                 onClick={goToServitorSignup}
//               >
//                 <i className="fas fa-briefcase"></i>
//                 <span>
//                   {t("home.cta_become_servitor", {
//                     defaultValue: "Become a Provider",
//                   })}
//                 </span>
//               </button>
//             </div>
//           </div>

//           {/* Hero Visual - Desktop Right */}

//           {/* <div className="homepage-hero-visual desktop-right">
//             <div className="homepage-floating-animation">
//               <div className="homepage-visual-outer">
//                 <div className="homepage-visual-middle">
//                   <div className="homepage-visual-inner">
//                     <i className="fas fa-handshake"></i>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div> */}

//           <div className="homepage-hero-visual desktop-right">
//             <div className="homepage-floating-animation">
//               <div className="homepage-hero-poster">
//                 <img
//                   src={require("../../Assets/HelpNao-Hero_img.png")}
//                   alt="HelpNao Hero Poster"
//                   className="homepage-hero-image"
//                 />
//               </div>
//             </div>
//           </div>

//         </div>
//       </section>

//       {/* SERVICES SECTION */}
//       <section className="homepage-services" ref={servicesRef} id="services">
//         <div className="homepage-services-container">
//           <div className="homepage-services-header">
//             <h2>{t("home.our_services")}</h2>
//             {/* <p>From home maintenance to personal assistance, we've got you covered with trusted professionals</p> */}
//           </div>

//           {/* <div className="homepage-service-grid">
//             {services.map((service, index) => {
//               const serviceKey = getServiceKey(service.services_name);
//               const translatedName =
//                 i18n.language === "bn"
//                   ? t(`home.services.${serviceKey}.name`, {
//                       defaultValue: service.services_name,
//                     })
//                   : service.services_name;

//               return (
//                 <div
//                   className={`homepage-service-card service-${index + 1}`}
//                   key={service.Id}
//                   onClick={() => handleCardClick(service.services_name)}
//                 >
//                   <div className="homepage-service-icon">
//                     <i className={getServiceIcon(service.services_name)}></i>
//                   </div>
//                   <h3>{translatedName}</h3>
//                 </div>
//               );
//             })}
//           </div> */}

//           <div className="homepage-service-grid">
//             {services.map((service) => {
//               const serviceKey = getServiceKey(service.services_name);
//               const translatedName =
//                 i18n.language === "bn"
//                   ? t(`home.services.${serviceKey}.name`, {
//                       defaultValue: service.services_name,
//                     })
//                   : service.services_name;

//               return (
//                 <button
//                   type="button"
//                   className="service-tile"
//                   key={service.Id}
//                   onClick={() => handleCardClick(service.services_name)}
//                   aria-label={translatedName}
//                   title={translatedName}
//                 >
//                   <div className="service-thumb">
//                     <img
//                       src={`${URL}/uploads/${service.image}`}
//                       alt={translatedName}
//                       loading="lazy"
//                       draggable={false}
//                       onError={(e) => {
//                         // graceful fallback: hide broken img, show icon background
//                         e.currentTarget.style.display = "none";
//                         e.currentTarget.parentElement?.classList.add(
//                           "fallback"
//                         );
//                       }}
//                     />
//                     <i
//                       className="fas fa-cog fallback-icon"
//                       aria-hidden="true"
//                     ></i>
//                   </div>
//                   <div className="service-name">{translatedName}</div>
//                 </button>
//               );
//             })}
//           </div>
//         </div>
//       </section>



//       {/* FULL BUILDING SERVICE SECTION */}
//       <section className="homepage-fullbuilding">
//         <div className="homepage-fullbuilding-container">
//           <div className="homepage-fullbuilding-header">
//             <h2>
//               {t("home.fullBuilding.title", {
//                 defaultValue: "Full Building Services",
//               })}
//             </h2>
//             <p>
//               {t("home.fullBuilding.subtitle", {
//                 defaultValue:
//                   "End-to-end electrical, plumbing, painting and interior work for entire buildings and projects.",
//               })}
//             </p>
//           </div>

//           <button
//             type="button"
//             className="homepage-fullbuilding-card"
//             onClick={() => navigate("/services/full-building")}
//           >
//             {/* TOP ROW: ICON + BADGE */}
//             <div className="homepage-fullbuilding-top">
//               <div className="homepage-fullbuilding-icon">
//                 <i className="fas fa-building" aria-hidden="true" />
//               </div>

//               <div className="homepage-fullbuilding-badge">
//                 {t("home.fullBuilding.badge", {
//                   defaultValue: "Project / Whole Building",
//                 })}
//               </div>
//             </div>

//             {/* MAIN TEXT */}
//             <div className="homepage-fullbuilding-main">
//               <div className="homepage-fullbuilding-text">
//                 <h3>
//                   {t("home.fullBuilding.cardTitle", {
//                     defaultValue: "Need Service for a Full Building?",
//                   })}
//                 </h3>
//                 <p>
//                   {t("home.fullBuilding.cardBody", {
//                     defaultValue:
//                       "Share your building details and requirements to get a customized quotation & dedicated support from HelpNao.",
//                   })}
//                 </p>

//                 <span className="homepage-fullbuilding-cta">
//                   <span className="homepage-fullbuilding-cta-label">
//                     {t("home.fullBuilding.cta", {
//                       defaultValue: "Request Full Building Service",
//                     })}
//                   </span>
//                   <i className="fas fa-arrow-right" aria-hidden="true" />
//                 </span>
//               </div>
//             </div>
//           </button>
//         </div>
//       </section>


//       {/* HOW IT WORKS */}
//       {/* <section className="homepage-howitworks" id="how-it-works">
//         <div className="homepage-howitworks-container">
//           <div className="homepage-howitworks-header">
//             <h2>
//               {t("home.hiw.title", { defaultValue: "How HelpNao Works" })}
//             </h2>
//             <p>
//               {t("home.hiw.subtitle", {
//                 defaultValue: "Simple steps to connect, serve, and earn",
//               })}
//             </p>
//           </div>
//           <div className="homepage-howitworks-block">
//             <h3 className="homepage-howitworks-subtitle seekers">
//               {t("home.hiw.seekers", { defaultValue: "For Service Seekers" })}
//             </h3>
//             <div className="homepage-howitworks-grid">
//               <div className="homepage-howitworks-card">
//                 <div className="homepage-howitworks-icon primary">
//                   <i className="fas fa-user-plus" />
//                 </div>
//                 <h4>1. {t("home.hiw.sign_up", { defaultValue: "Sign Up" })}</h4>
//                 <p>
//                   {t("home.hiw.sign_up_desc", {
//                     defaultValue:
//                       "Create your account and tell us about your needs",
//                   })}
//                 </p>
//               </div>
//               <div className="homepage-howitworks-card">
//                 <div className="homepage-howitworks-icon primary">
//                   <i className="fas fa-search" />
//                 </div>
//                 <h4>
//                   2.{" "}
//                   {t("home.hiw.browse", { defaultValue: "Browse Services" })}
//                 </h4>
//                 <p>
//                   {t("home.hiw.browse_desc", {
//                     defaultValue: "Explore our wide range of home services",
//                   })}
//                 </p>
//               </div>
//               <div className="homepage-howitworks-card">
//                 <div className="homepage-howitworks-icon primary">
//                   <i className="fas fa-calendar-check" />
//                 </div>
//                 <h4>
//                   3. {t("home.hiw.book", { defaultValue: "Book Service" })}
//                 </h4>
//                 <p>
//                   {t("home.hiw.book_desc", {
//                     defaultValue:
//                       "Place your order and schedule at your convenience",
//                   })}
//                 </p>
//               </div>
//               <div className="homepage-howitworks-card">
//                 <div className="homepage-howitworks-icon primary">
//                   <i className="fas fa-smile" />
//                 </div>
//                 <h4>4. {t("home.hiw.relax", { defaultValue: "Relax" })}</h4>
//                 <p>
//                   {t("home.hiw.relax_desc", {
//                     defaultValue:
//                       "Sit back while our verified professionals handle everything",
//                   })}
//                 </p>
//               </div>
//             </div>
//           </div>

//           <div className="homepage-howitworks-block">
//             <h3 className="homepage-howitworks-subtitle providers">
//               {t("home.hiw.providers", {
//                 defaultValue: "For Service Providers",
//               })}
//             </h3>
//             <div className="homepage-howitworks-highlight">
//               <h4>
//                 💰{" "}
//                 {t("home.hiw.earn_banner", {
//                   defaultValue: "Earn Up to ৳50,000+ Monthly",
//                 })}
//               </h4>
//               <p>
//                 {t("home.hiw.earn_desc", {
//                   defaultValue:
//                     "Join our platform and start earning with flexible working hours",
//                 })}
//               </p>
//             </div>
//             <div className="homepage-howitworks-grid">
//               <div className="homepage-howitworks-card">
//                 <div className="homepage-howitworks-icon secondary">
//                   <i className="fas fa-id-card" />
//                 </div>
//                 <h4>
//                   1. {t("home.hiw.register", { defaultValue: "Register" })}
//                 </h4>
//                 <p>
//                   {t("home.hiw.register_desc", {
//                     defaultValue: "Sign up and get verified with your skills",
//                   })}
//                 </p>
//               </div>
//               <div className="homepage-howitworks-card">
//                 <div className="homepage-howitworks-icon secondary">
//                   <i className="fas fa-bell" />
//                 </div>
//                 <h4>
//                   2. {t("home.hiw.requests", { defaultValue: "Get Requests" })}
//                 </h4>
//                 <p>
//                   {t("home.hiw.requests_desc", {
//                     defaultValue: "Receive service requests in your area",
//                   })}
//                 </p>
//               </div>
//               <div className="homepage-howitworks-card">
//                 <div className="homepage-howitworks-icon secondary">
//                   <i className="fas fa-tools" />
//                 </div>
//                 <h4>
//                   3.{" "}
//                   {t("home.hiw.provide", { defaultValue: "Provide Service" })}
//                 </h4>
//                 <p>
//                   {t("home.hiw.provide_desc", {
//                     defaultValue: "Deliver quality service to customers",
//                   })}
//                 </p>
//               </div>
//               <div className="homepage-howitworks-card">
//                 <div className="homepage-howitworks-icon secondary">
//                   <i className="fas fa-money-bill-wave" />
//                 </div>
//                 <h4>4. {t("home.hiw.earn", { defaultValue: "Earn Money" })}</h4>
//                 <p>
//                   {t("home.hiw.earn_desc", {
//                     defaultValue: "Get paid instantly for your excellent work",
//                   })}
//                 </p>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section> */}

//       {/* HOW TO START WITH HelpNao */}
//       <section className="homepage-howitworks" id="how-to-start">
//         <div className="homepage-howitworks-container">
//           <div className="homepage-howitworks-header">
//             <h2>
//               {t("home.start.title", {
//                 defaultValue: "How to Start with HelpNao",
//               })}
//             </h2>
//             <p>
//               {t("home.start.subtitle", {
//                 defaultValue: "Simple steps to get started on our platform",
//               })}
//             </p>
//           </div>

//           {/* Service Seekers Section */}
//           <div className="homepage-start-section">
//             <div className="homepage-start-grid">
//               {/* Left Column - Text Content */}
//               <div className="homepage-start-content seekers">
//                 <div className="homepage-start-content-inner">
//                   <h3>
//                     {t("home.start.seeking_title", {
//                       defaultValue: "Searching For",
//                     })}{" "}
//                     <span className="highlight-blue">
//                       {t("home.start.services", { defaultValue: "Services?" })}
//                     </span>
//                   </h3>
//                   <p className="homepage-start-subtitle">
//                     {t("home.start.seeking_desc", {
//                       defaultValue:
//                         "How to place your order in just a few simple steps",
//                     })}
//                   </p>

//                   {/* Steps */}
//                   <div className="homepage-start-steps">
//                     <div className="homepage-start-step">
//                       <div className="homepage-start-step-number blue">1</div>
//                       <div className="homepage-start-step-content">
//                         <h4>
//                           {t("home.start.choose_service", {
//                             defaultValue: "Log in & Choose Your Service",
//                           })}
//                         </h4>
//                         <p>
//                           {t("home.start.choose_service_desc", {
//                             defaultValue:
//                               "Browse our categories and select the service you need",
//                           })}
//                         </p>
//                       </div>
//                     </div>
//                     <div className="homepage-start-step">
//                       <div className="homepage-start-step-number blue">2</div>
//                       <div className="homepage-start-step-content">
//                         <h4>
//                           {t("home.start.book_schedule", {
//                             defaultValue: "Book & Schedule",
//                           })}
//                         </h4>
//                         <p>
//                           {t("home.start.book_schedule_desc", {
//                             defaultValue:
//                               "Pick your preferred time and confirm your booking",
//                           })}
//                         </p>
//                       </div>
//                     </div>
//                     <div className="homepage-start-step">
//                       <div className="homepage-start-step-number blue">3</div>
//                       <div className="homepage-start-step-content">
//                         <h4>
//                           {t("home.start.enjoy_service", {
//                             defaultValue: "Enjoy Quality Service",
//                           })}
//                         </h4>
//                         <p>
//                           {t("home.start.enjoy_service_desc", {
//                             defaultValue:
//                               "Relax while our verified professionals take care of everything",
//                           })}
//                         </p>
//                       </div>
//                     </div>
//                   </div>

//                   <button className="homepage-start-btn blue">
//                     {t("home.start.start_booking", {
//                       defaultValue: "Start Booking Now",
//                     })}
//                   </button>
//                 </div>
//               </div>

//               {/* Right Column - Illustration */}
//               <div className="homepage-start-visual seekers">
//                 <div className="homepage-start-mockup">
//                   <div className="homepage-start-card">
//                     <div className="homepage-start-icon-large blue">
//                       <i className="fas fa-calendar-check"></i>
//                     </div>
//                     <h4>
//                       {t("home.start.easy_booking", {
//                         defaultValue: "Easy Booking",
//                       })}
//                     </h4>
//                     <p>
//                       {t("home.start.easy_booking_desc", {
//                         defaultValue: "Schedule services at your convenience",
//                       })}
//                     </p>

//                     {/* Mock service icons */}
//                     <div className="homepage-start-service-icons">
//                       <div className="homepage-start-service-icon">
//                         <i className="fas fa-bolt"></i>
//                       </div>
//                       <div className="homepage-start-service-icon">
//                         <i className="fas fa-broom"></i>
//                       </div>
//                       <div className="homepage-start-service-icon">
//                         <i className="fas fa-tools"></i>
//                       </div>
//                     </div>
//                   </div>
//                   <div className="homepage-start-bubble bubble-1"></div>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Service Providers Section */}
//           {/* <div className="homepage-start-section">
//       <div className="homepage-start-grid providers">

//         <div className="homepage-start-visual providers">
//           <div className="homepage-start-mockup">
//             <div className="homepage-start-card">
//               <div className="homepage-start-icon-large green">
//                 <i className="fas fa-dollar-sign"></i>
//               </div>
//               <h4>
//                 {t("home.start.start_earning", { defaultValue: "Start Earning" })}
//               </h4>
//               <p>
//                 {t("home.start.start_earning_desc", {
//                   defaultValue: "Turn your skills into income",
//                 })}
//               </p>

//               <div className="homepage-start-earnings">
//                 <div className="homepage-start-earning-item">
//                   <span className="label">
//                     {t("home.start.this_month", { defaultValue: "This Month" })}
//                   </span>
//                   <span className="value">৳3,250</span>
//                 </div>
//                 <div className="homepage-start-earning-item">
//                   <span className="label">
//                     {t("home.start.jobs_completed", { defaultValue: "Jobs Completed" })}
//                   </span>
//                   <span className="value">47</span>
//                 </div>
//                 <div className="homepage-start-earning-item">
//                   <span className="label">
//                     {t("home.start.rating", { defaultValue: "Rating" })}
//                   </span>
//                   <span className="value">4.9 ⭐</span>
//                 </div>
//               </div>
//             </div>
//             <div className="homepage-start-bubble bubble-2"></div>
//           </div>
//         </div>

//         <div className="homepage-start-content providers">
//           <div className="homepage-start-content-inner">
//             <h3>
//               {t("home.start.want_earning", { defaultValue: "Want to Start" })}{" "}
//               <span className="highlight-green">
//                 {t("home.start.earning", { defaultValue: "Earning?" })}
//               </span>
//             </h3>
//             <p className="homepage-start-subtitle">
//               {t("home.start.want_earning_desc", {
//                 defaultValue: "Join our community of professional service providers",
//               })}
//             </p>
//             <p className="homepage-start-earning-highlight">
//               💰{" "}
//               {t("home.start.earn_amount", {
//                 defaultValue: "Earn up to ৳50,000+ Monthly",
//               })}
//             </p>

//             <div className="homepage-start-steps">
//               <div className="homepage-start-step">
//                 <div className="homepage-start-step-number green">1</div>
//                 <div className="homepage-start-step-content">
//                   <h4>
//                     {t("home.start.register_verify", {
//                       defaultValue: "Register & Verify",
//                     })}
//                   </h4>
//                   <p>
//                     {t("home.start.register_verify_desc", {
//                       defaultValue: "Sign up and complete our quick verification process",
//                     })}
//                   </p>
//                 </div>
//               </div>
//               <div className="homepage-start-step">
//                 <div className="homepage-start-step-number green">2</div>
//                 <div className="homepage-start-step-content">
//                   <h4>
//                     {t("home.start.get_requests", {
//                       defaultValue: "Get Job Requests",
//                     })}
//                   </h4>
//                   <p>
//                     {t("home.start.get_requests_desc", {
//                       defaultValue: "Receive service requests from customers in your area",
//                     })}
//                   </p>
//                 </div>
//               </div>
//               <div className="homepage-start-step">
//                 <div className="homepage-start-step-number green">3</div>
//                 <div className="homepage-start-step-content">
//                   <h4>
//                     {t("home.start.earn_grow", { defaultValue: "Earn & Grow" })}
//                   </h4>
//                   <p>
//                     {t("home.start.earn_grow_desc", {
//                       defaultValue: "Complete jobs, earn money, and build your reputation",
//                     })}
//                   </p>
//                 </div>
//               </div>
//             </div>

//             <button className="homepage-start-btn green">
//               {t("home.start.start_earning_today", {
//                 defaultValue: "Start Earning Today",
//               })}
//             </button>
//           </div>
//         </div>
//       </div>
//     </div> */}
//         </div>
//       </section>

//       {/* COVERAGE SECTION */}
//       <section className="homepage-coverage" id="coverage">
//         <div className="homepage-coverage-container">
//           <div className="homepage-coverage-header">
//             <h2>
//               {t("home.coverage.title", {
//                 defaultValue: "We're available in your city",
//               })}
//             </h2>
//             <p>
//               {t("home.coverage.sub", {
//                 defaultValue:
//                   "Pick a city to see the active service areas we cover right now.",
//               })}
//             </p>
//           </div>

//           <div className="homepage-coverage-controls">
//             <div className="homepage-coverage-selector">
//               <label htmlFor="coverage-city">
//                 <i className="fas fa-city"></i>
//                 {t("home.coverage.city", { defaultValue: "City" })}
//               </label>
//               <select
//                 id="coverage-city"
//                 value={selectedCityId}
//                 onChange={async (e) => {
//                   const id = e.target.value;
//                   setSelectedCityId(id);
//                   setAreas([]);
//                   await loadAreas(id);
//                 }}
//               >
//                 {divisions.map((d) => (
//                   <option key={d.Id} value={String(d.Id)}>
//                     {d.name}
//                   </option>
//                 ))}
//               </select>
//               <div className="homepage-coverage-count">
//                 <i className="fas fa-map-pin"></i>
//                 {t("home.coverage.areas_count", {
//                   count: areas.length,
//                   defaultValue: `${areas.length} active areas`,
//                 })}
//               </div>
//             </div>
//           </div>

//           <div className="homepage-coverage-areas">
//             {areas.length === 0 ? (
//               <div className="homepage-coverage-empty">
//                 {t("home.coverage.empty", {
//                   defaultValue: "No active areas listed for this city yet.",
//                 })}
//               </div>
//             ) : (
//               areas.map((a) => (
//                 <div key={a.Id} className="homepage-coverage-chip">
//                   <i className="fas fa-map-marker-alt"></i>
//                   <span>{a.name}</span>
//                 </div>
//               ))
//             )}
//           </div>
//         </div>
//       </section>

//       {/* NEW: EARN MONEY SECTION (after coverage) */}
//       <section className="homepage-earn" id="earn-with-HelpNao">
//         {" "}
//         {/* NEW */}
//         <div className="homepage-earn-container">
//           <div className="homepage-earn-content">
//             <h2>
//               {t("home.earn.title", {
//                 defaultValue: "Earn money with your skills",
//               })}
//             </h2>
//             <p>
//               {t("home.earn.subtitle", {
//                 defaultValue:
//                   "Join thousands of professionals using HelpNao to find nearby jobs, manage bookings, and grow a steady income on your schedule.",
//               })}
//             </p>
//             <button className="homepage-earn-btn" onClick={goToServitorSignup}>
//               <i className="fas fa-rocket" aria-hidden="true"></i>
//               <span>
//                 {t("home.earn.cta", { defaultValue: "Start Earning" })}
//               </span>
//             </button>
//           </div>
//         </div>
//         {/* Full-width responsive banner */}
//         <div className="homepage-earn-banner full-bleed">
//           <img
//             src={Banner}
//             alt={t("home.earn.banner_alt", {
//               defaultValue: "Earn with HelpNao",
//             })}
//             loading="lazy"
//             decoding="async"
//           />
//         </div>
//       </section>

//       <FeedbackPage />

//       {/* MOBILE APP SECTION */}
//       {/* <section className="homepage-app" id="app">
//         <div className="homepage-app-container">
//           <div className="homepage-app-grid">
//             <div className="homepage-app-content">
//               <h2>
//                 {t("home.app.title", {
//                   defaultValue: "Download Our Mobile App",
//                 })}
//               </h2>
//               <p>
//                 {t("home.app.subtitle", {
//                   defaultValue:
//                     "Get the full HelpNao experience on your phone. Book services, track providers, and manage your account on the go.",
//                 })}
//               </p>

//               <div className="homepage-store-buttons">
//                 <button
//                   type="button"
//                   className="homepage-store-btn"
//                   onClick={() =>
//                     window.open(
//                       "https://play.google.com/store/apps/details?id=your.app.id",
//                       "_blank"
//                     )
//                   }
//                 >
//                   <img src={Playsore} alt="Get it on Google Play" />
//                 </button>
//               </div>
//             </div>

//             <div className="homepage-app-mockup">
//               <div className="homepage-phone-wrapper">
//                 <div className="homepage-phone-bubble bubble-1"></div>
//                 <div className="homepage-phone-bubble bubble-2"></div>
//                 <div className="homepage-phone-bubble bubble-3"></div>

//                 <div className="homepage-phone">
//                   <div className="homepage-phone-notch"></div>
//                   <div className="homepage-phone-screen">
//                     <div className="homepage-phone-content">
//                       <i className="fas fa-mobile-alt"></i>
//                       <div className="homepage-phone-title">HelpNao</div>
//                       <div className="homepage-phone-subtitle">
//                         {t("home.app.card", { defaultValue: "App Preview" })}
//                       </div>
//                       <div className="homepage-phone-badge">
//                         {t("home.app.cardSoon", {
//                           defaultValue: "Coming Soon",
//                         })}
//                       </div>
//                     </div>
//                   </div>
//                   <div className="homepage-phone-homebar"></div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section> */}

//       <Footer />


//       {/* NEW: Floating Back-to-Top button */}
//       <button
//         type="button"
//         className={`scrolltop-btn ${showScrollTop ? "show" : ""}`}
//         onClick={scrollToTop}
//         aria-label={t("home.back_to_top", { defaultValue: "Back to top" })}
//         title={t("home.back_to_top", { defaultValue: "Back to top" })}
//       >
//         <i className="fas fa-arrow-up" aria-hidden="true"></i>
//       </button>
      
//     </>
//   );
// };

// export default Home;




// ***** Update with new design and hide for login user (6-January-2026) ***** //
import React, { useState, useEffect, useCallback, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "./homeStyle.css";
import Navbar from "../../Components/Navbar";
import Footer from "../../Components/Footer/Footer";
// import Banner from "../../Assets/HELP.jpg";
// import Banner from "../../Assets/Helpnaeservice.png";
import Banner from "../../Assets/HelpNao-Banner-Starearning.png";
// import AppStore from "../../Assets/Apple.png";
// import Playsore from "../../Assets/Google_Play_Store_badge.png";
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import { useTranslation } from "react-i18next";
import FeedbackPage from "../Feedback/FeedbackPage";
import { URL } from "../../config";
import Loader from "../../Components/LoaderSpin/Loader";
import SEO from "../../Components/SEO/SEO";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { 
  faReceipt, 
  faSun, 
  faMoon,
  faSearch,
  faBriefcase,
  faBuilding,
  faArrowRight,
  faArrowUp,

  faCity,
  faMapPin,
  faMapMarkerAlt,
  faRocket,

  faCog,

  faCalendarCheck,
  faBolt,
  faSnowflake,
  faScrewdriverWrench,

 } from "@fortawesome/free-solid-svg-icons";


const Home = () => {
  const { t, i18n } = useTranslation();
  const [services, setServices] = useState([]);
  const navigate = useNavigate();

  // Coverage state
  const [divisions, setDivisions] = useState([]);
  const [areas, setAreas] = useState([]);
  const [selectedCityId, setSelectedCityId] = useState("");

  // For loader
  const [loadingServices, setLoadingServices] = useState(true);
  const [loadingDivisions, setLoadingDivisions] = useState(true);
  const [loadingAreas, setLoadingAreas] = useState(true);

  const [showScrollTop, setShowScrollTop] = useState(false);


  // Smooth scroll to Services
  const servicesRef = useRef(null);

  // Checking user logged in or not
  const isLoggedIn = !!localStorage.getItem("token");


  // Logged-in user display name (from JWT payload)
// Logged-in user display name (ONLY real name, no number)
const [displayName, setDisplayName] = useState("");

const cleanName = (v) => {
  const s = String(v || "").trim();
  if (!s) return "";
  // if it's only digits (like a phone), ignore it
  if (/^\d+$/.test(s)) return "";
  return s;
};

const getUserIdFromToken = (token) => {
  try {
    if (!token) return "";
    const decoded = jwtDecode(token);
    const raw = decoded?.Id || decoded?.id || decoded?.userId || decoded?.user_id || "";
    if (!raw) return "";
    const str = String(raw);
    return str.startsWith("user-") ? str.split("user-")[1] : str;
  } catch {
    return "";
  }
};

useEffect(() => {
  if (!isLoggedIn) {
    setDisplayName("");
    return;
  }

  const token = localStorage.getItem("token");
  const userId = getUserIdFromToken(token);
  if (!userId) {
    setDisplayName("");
    return;
  }

  let cancelled = false;

  (async () => {
    try {
      const { data } = await axios.get(`${URL}/user/${userId}`, {
        params: { lang: i18n.language },
        headers: { Authorization: `Bearer ${token}` },
      });

      const full =
        cleanName([data?.FirstName, data?.LastName].filter(Boolean).join(" ")) ||
        cleanName(data?.name) ||
        cleanName(data?.fullName) ||
        "";

      if (!cancelled) setDisplayName(full);
    } catch (e) {
      if (!cancelled) setDisplayName("");
    }
  })();

  return () => {
    cancelled = true;
  };
}, [isLoggedIn, i18n.language]);

const getGreetingMeta = () => {
  const h = new Date().getHours();

  if (h < 12) return { key: "home.greeting.morning", icon: faSun, isNight: false };
  if (h < 18) return { key: "home.greeting.afternoon", icon: faSun, isNight: false };
  return { key: "home.greeting.evening", icon: faMoon, isNight: true };
};
  

  const showLoader = loadingServices || loadingDivisions || loadingAreas;

  const fetchServices = useCallback(async () => {
    setLoadingServices(true);
    try {
      const response = await axios.get(`${URL}/services`, {
        params: { lang: i18n.language },
      });
      setServices(response.data);
    } catch (error) {
      console.error("Error fetching services:", error);
    } finally {
    setLoadingServices(false);
  }
  }, [i18n.language]);

  useEffect(() => {
    fetchServices();
  }, [fetchServices]);

  // Load divisions (cities) on mount
  useEffect(() => {
    const loadDivisions = async () => {
      setLoadingDivisions(true);
      try {
        const { data } = await axios.get(
          `${URL}/locations/divisions`
        );
        const list = Array.isArray(data) ? data : [];
        setDivisions(list);

        const preferredNames = ["Dhaka", "ঢাকা"];
        const dhaka =
          list.find((d) =>
            preferredNames.some(
              (n) => String(d.name || "").toLowerCase() === n.toLowerCase()
            )
          ) || list[0];

        if (dhaka) {
          setSelectedCityId(String(dhaka.Id));
          await loadAreas(dhaka.Id);
        }
      } catch (e) {
        console.error("Error loading divisions:", e);
        setDivisions([]);
      }
      finally {
      setLoadingDivisions(false);
    }
    };
    loadDivisions();
  }, []);

  // Load areas for a division
  const loadAreas = async (divisionId) => {
    if (!divisionId) {
      setAreas([]);
      return;
    }
    setLoadingAreas(true);
    try {
      const { data } = await axios.get(
        `${URL}/locations/areas`,
        {
          params: { divisionId },
        }
      );
      setAreas(Array.isArray(data) ? data : []);
    } catch (e) {
      console.error("Error loading areas:", e);
      setAreas([]);
    } finally {
    setLoadingAreas(false);
  }
  };


  useEffect(() => {
    let ticking = false;

    const onScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          setShowScrollTop(window.scrollY > 320);
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll(); // run once on mount
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // NEW: smooth scroll to top
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };



  const handleCardClick = (serviceName) => {
    const servicePath = serviceName.toLowerCase().replace(/\s+/g, "-");
    navigate(`/services/${servicePath}`);
  };

  const handleScrollToServices = () => {
    if (servicesRef.current) {
      servicesRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  const goToServitorSignup = () => {
    navigate("/earnwithHelpNao");
  };

  const getServiceKey = (serviceName) => {
    return serviceName.trim().toLowerCase().replace(/\s+/g, "_");
  };

  // Service icon mapping
  // const getServiceIcon = (serviceName) => {
  //   const iconMap = {
  //     electrician: "fas fa-bolt",
  //     "home cleaning": "fas fa-broom",
  //     plumber: "fas fa-toolbox",
  //     "ac service": "fas fa-snowflake",
  //     "filter": "fas fa-tint",
  //     "gas chula": "fas fa-fire",
  //     "tutor service": "fas fa-graduation-cap",
  //   };
  //   return iconMap[serviceName.toLowerCase()] || "fas fa-cog";
  // };


  const ICON = {
    search: faSearch,
    briefcase: faBriefcase,
    building: faBuilding,
    arrowRight: faArrowRight,
    arrowUp: faArrowUp,

    city: faCity,
    mapPin: faMapPin,
    mapMarker: faMapMarkerAlt,
    rocket: faRocket,

    cog: faCog,

    calendarCheck: faCalendarCheck,
    bolt: faBolt,
    ac: faSnowflake,
    tools: faScrewdriverWrench,
  };


  return (
    <>

    {/* For SEO */}
    <SEO
      title={
        i18n.language === "bn"
          ? "HelpNao | বাংলাদেশে অন-ডিমান্ড হোম সার্ভিস"
          : "HelpNao | On-demand Home Services in Bangladesh"
      }
      description={
        i18n.language === "bn"
          ? "HelpNao – ইলেকট্রিশিয়ান, প্লাম্বার, এসি সার্ভিস, গ্যাস চুলা ও হোম সার্ভিস বুক করুন সহজে। যাচাইকৃত ও বিশ্বস্ত সার্ভিস প্রোভাইডার। দরকার সাহায্য? Just HelpNao."
          : "HelpNao – Book trusted electricians, plumbers, AC service, gas chula repair & more. Verified professionals, fast booking across Bangladesh. Need help? Just HelpNao."
      }
      path="/"
      lang={i18n.language === "bn" ? "bn" : "en"}
      jsonLd={[
        {
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "HelpNao",
          "url": "https://helpnao.com",
          "logo": "https://helpnao.com/HelpNao192.png",
          "sameAs": []
        },
        {
          "@context": "https://schema.org",
          "@type": "WebSite",
          "name": "HelpNao",
          "url": "https://helpnao.com"
        }
      ]}
    />

      {/* For loader */}
      <Loader
        show={showLoader}
        brand="HelpNao"
        message={t("home.loaderMessage", {
          defaultValue: "Connecting you with trusted service providers...",
        })}
      />
      <Navbar />

      {isLoggedIn && (
        <section
          className="homepage-welcome homepage-welcome--logged"
          aria-label="Welcome"
        >
          <div className="homepage-welcome-inner homepage-welcome-inner--simple">
            <div className="homepage-welcome-text">
              {(() => {
                const g = getGreetingMeta();
                return (
                  <div className="homepage-welcome-kicker">
                    <span className={`homepage-welcome-sun ${g.isNight ? "is-moon" : "is-sun"}`} aria-hidden="true">
                      <FontAwesomeIcon icon={g.icon} />
                    </span>

                    <span className="homepage-welcome-greet">
                      {/* {g.text} */}
                      {t(g.key)}
                      <span className="homepage-welcome-comma">,</span>
                    </span>
                  </div>
                );
              })()}

              {displayName ? (
                <div className="homepage-welcome-nameLine">{displayName}</div>
              ) : null}
            </div>

            <div className="homepage-welcome-actions">
              <button
                type="button"
                className="homepage-welcome-ordersBtn"
                onClick={() => navigate("/profile/orderhistory")}
              >
                <FontAwesomeIcon icon={faReceipt} className="hn-icon receipt" aria-hidden="true" />
                <span>{t("home.myOrders", { defaultValue: "My Orders" })}</span>
              </button>
            </div>
          </div>
        </section>
      )}

      {/* HERO SECTION (spacing tightened below in CSS) */}
      {!isLoggedIn && (
        <section className="homepage-hero">
          <div className="homepage-hero-container">
            {/* Hero Visual - Mobile Top */}

            {/* <div className="homepage-hero-visual mobile-top">
            <div className="homepage-floating-animation">
              <div className="homepage-visual-outer">
                <div className="homepage-visual-middle">
                  <div className="homepage-visual-inner">
                    <i className="fas fa-handshake"></i>
                  </div>
                </div>
              </div>
            </div>
          </div> */}

            <div className="homepage-hero-visual mobile-top">
              <div className="homepage-floating-animation">
                <div className="homepage-hero-poster">
                  <img
                    src={require("../../Assets/HelpNao-Hero_img.png")}
                    alt="HelpNao Hero Poster"
                    className="homepage-hero-image"
                  />
                </div>
              </div>
            </div>

            {/* Hero Content */}
            <div className="homepage-hero-content">
              <h1 dangerouslySetInnerHTML={{ __html: t("home.welcome") }} />
              <p>{t("home.description")}</p>

              <div className="homepage-hero-buttons">
                <button
                  className="homepage-btn-primary"
                  onClick={handleScrollToServices}
                >
                  {/* <i className="fas fa-search"></i> */}
                  <FontAwesomeIcon icon={ICON.search} aria-hidden="true" />
                  <span>
                    {t("home.cta_book_service", {
                      defaultValue: "Book a Service",
                    })}
                  </span>
                </button>
                <button
                  className="homepage-btn-secondary"
                  onClick={goToServitorSignup}
                >
                  {/* <i className="fas fa-briefcase"></i> */}
                  <FontAwesomeIcon icon={ICON.briefcase} aria-hidden="true" />
                  <span>
                    {t("home.cta_become_servitor", {
                      defaultValue: "Become a Provider",
                    })}
                  </span>
                </button>
              </div>
            </div>

            {/* Hero Visual - Desktop Right */}

            {/* <div className="homepage-hero-visual desktop-right">
            <div className="homepage-floating-animation">
              <div className="homepage-visual-outer">
                <div className="homepage-visual-middle">
                  <div className="homepage-visual-inner">
                    <i className="fas fa-handshake"></i>
                  </div>
                </div>
              </div>
            </div>
          </div> */}

            <div className="homepage-hero-visual desktop-right">
              <div className="homepage-floating-animation">
                <div className="homepage-hero-poster">
                  <img
                    src={require("../../Assets/HelpNao-Hero_img.png")}
                    alt="HelpNao Hero Poster"
                    className="homepage-hero-image"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* SERVICES SECTION */}
      <section
        // className="homepage-services"
        className={`homepage-services ${
          isLoggedIn ? "homepage-services-compact" : ""
        }`}
        ref={servicesRef}
        id="services"
      >
        <div className="homepage-services-container">
          {!isLoggedIn && (
            <div className="homepage-services-header">
              <h2>{t("home.our_services")}</h2>
              {/* <p>From home maintenance to personal assistance, we've got you covered with trusted professionals</p> */}
            </div>
          )}

          {/* <div className="homepage-service-grid">
            {services.map((service, index) => {
              const serviceKey = getServiceKey(service.services_name);
              const translatedName =
                i18n.language === "bn"
                  ? t(`home.services.${serviceKey}.name`, {
                      defaultValue: service.services_name,
                    })
                  : service.services_name;

              return (
                <div
                  className={`homepage-service-card service-${index + 1}`}
                  key={service.Id}
                  onClick={() => handleCardClick(service.services_name)}
                >
                  <div className="homepage-service-icon">
                    <i className={getServiceIcon(service.services_name)}></i>
                  </div>
                  <h3>{translatedName}</h3>
                </div>
              );
            })}
          </div> */}

          <div className="homepage-service-grid">
            {services.map((service) => {
              const serviceKey = getServiceKey(service.services_name);
              const translatedName =
                i18n.language === "bn"
                  ? t(`home.services.${serviceKey}.name`, {
                      defaultValue: service.services_name,
                    })
                  : service.services_name;

              return (
                <button
                  type="button"
                  className="service-tile"
                  key={service.Id}
                  onClick={() => handleCardClick(service.services_name)}
                  aria-label={translatedName}
                  title={translatedName}
                >
                  <div className="service-thumb">
                    <img
                      src={`${URL}/uploads/${service.image}`}
                      alt={translatedName}
                      loading="lazy"
                      draggable={false}
                      onError={(e) => {
                        // graceful fallback: hide broken img, show icon background
                        e.currentTarget.style.display = "none";
                        e.currentTarget.parentElement?.classList.add(
                          "fallback"
                        );
                      }}
                    />
                    {/* <i
                      className="fas fa-cog fallback-icon"
                      aria-hidden="true"
                    ></i> */}
                    <FontAwesomeIcon icon={ICON.cog} className="fallback-icon" aria-hidden="true" />
                  </div>
                  <div className="service-name">{translatedName}</div>
                </button>
              );
            })}
          </div>
        </div>
      </section>

      {/* FULL BUILDING SERVICE SECTION */}
      <section className="homepage-fullbuilding">
        <div className="homepage-fullbuilding-container">
          <div className="homepage-fullbuilding-header">
            <h2>
              {t("home.fullBuilding.title", {
                defaultValue: "Full Building Services",
              })}
            </h2>
            <p>
              {t("home.fullBuilding.subtitle", {
                defaultValue:
                  "End-to-end electrical, plumbing, painting and interior work for entire buildings and projects.",
              })}
            </p>
          </div>

          <button
            type="button"
            className="homepage-fullbuilding-card"
            onClick={() => navigate("/services/full-building")}
          >
            {/* TOP ROW: ICON + BADGE */}
            <div className="homepage-fullbuilding-top">
              <div className="homepage-fullbuilding-icon">
                {/* <i className="fas fa-building" aria-hidden="true" /> */}
                <FontAwesomeIcon icon={ICON.building} aria-hidden="true" />
              </div>

              <div className="homepage-fullbuilding-badge">
                {t("home.fullBuilding.badge", {
                  defaultValue: "Project / Whole Building",
                })}
              </div>
            </div>

            {/* MAIN TEXT */}
            <div className="homepage-fullbuilding-main">
              <div className="homepage-fullbuilding-text">
                <h3>
                  {t("home.fullBuilding.cardTitle", {
                    defaultValue: "Need Service for a Full Building?",
                  })}
                </h3>
                <p>
                  {t("home.fullBuilding.cardBody", {
                    defaultValue:
                      "Share your building details and requirements to get a customized quotation & dedicated support from HelpNao.",
                  })}
                </p>

                <span className="homepage-fullbuilding-cta">
                  <span className="homepage-fullbuilding-cta-label">
                    {t("home.fullBuilding.cta", {
                      defaultValue: "Request Full Building Service",
                    })}
                  </span>
                  {/* <i className="fas fa-arrow-right" aria-hidden="true" /> */}
                  <FontAwesomeIcon icon={ICON.arrowRight} aria-hidden="true" />
                </span>
              </div>
            </div>
          </button>
        </div>
      </section>

      {/* HOW IT WORKS */}
      {/* <section className="homepage-howitworks" id="how-it-works">
        <div className="homepage-howitworks-container">
          <div className="homepage-howitworks-header">
            <h2>
              {t("home.hiw.title", { defaultValue: "How HelpNao Works" })}
            </h2>
            <p>
              {t("home.hiw.subtitle", {
                defaultValue: "Simple steps to connect, serve, and earn",
              })}
            </p>
          </div>
          <div className="homepage-howitworks-block">
            <h3 className="homepage-howitworks-subtitle seekers">
              {t("home.hiw.seekers", { defaultValue: "For Service Seekers" })}
            </h3>
            <div className="homepage-howitworks-grid">
              <div className="homepage-howitworks-card">
                <div className="homepage-howitworks-icon primary">
                  <i className="fas fa-user-plus" />
                </div>
                <h4>1. {t("home.hiw.sign_up", { defaultValue: "Sign Up" })}</h4>
                <p>
                  {t("home.hiw.sign_up_desc", {
                    defaultValue:
                      "Create your account and tell us about your needs",
                  })}
                </p>
              </div>
              <div className="homepage-howitworks-card">
                <div className="homepage-howitworks-icon primary">
                  <i className="fas fa-search" />
                </div>
                <h4>
                  2.{" "}
                  {t("home.hiw.browse", { defaultValue: "Browse Services" })}
                </h4>
                <p>
                  {t("home.hiw.browse_desc", {
                    defaultValue: "Explore our wide range of home services",
                  })}
                </p>
              </div>
              <div className="homepage-howitworks-card">
                <div className="homepage-howitworks-icon primary">
                  <i className="fas fa-calendar-check" />
                </div>
                <h4>
                  3. {t("home.hiw.book", { defaultValue: "Book Service" })}
                </h4>
                <p>
                  {t("home.hiw.book_desc", {
                    defaultValue:
                      "Place your order and schedule at your convenience",
                  })}
                </p>
              </div>
              <div className="homepage-howitworks-card">
                <div className="homepage-howitworks-icon primary">
                  <i className="fas fa-smile" />
                </div>
                <h4>4. {t("home.hiw.relax", { defaultValue: "Relax" })}</h4>
                <p>
                  {t("home.hiw.relax_desc", {
                    defaultValue:
                      "Sit back while our verified professionals handle everything",
                  })}
                </p>
              </div>
            </div>
          </div>

          <div className="homepage-howitworks-block">
            <h3 className="homepage-howitworks-subtitle providers">
              {t("home.hiw.providers", {
                defaultValue: "For Service Providers",
              })}
            </h3>
            <div className="homepage-howitworks-highlight">
              <h4>
                💰{" "}
                {t("home.hiw.earn_banner", {
                  defaultValue: "Earn Up to ৳50,000+ Monthly",
                })}
              </h4>
              <p>
                {t("home.hiw.earn_desc", {
                  defaultValue:
                    "Join our platform and start earning with flexible working hours",
                })}
              </p>
            </div>
            <div className="homepage-howitworks-grid">
              <div className="homepage-howitworks-card">
                <div className="homepage-howitworks-icon secondary">
                  <i className="fas fa-id-card" />
                </div>
                <h4>
                  1. {t("home.hiw.register", { defaultValue: "Register" })}
                </h4>
                <p>
                  {t("home.hiw.register_desc", {
                    defaultValue: "Sign up and get verified with your skills",
                  })}
                </p>
              </div>
              <div className="homepage-howitworks-card">
                <div className="homepage-howitworks-icon secondary">
                  <i className="fas fa-bell" />
                </div>
                <h4>
                  2. {t("home.hiw.requests", { defaultValue: "Get Requests" })}
                </h4>
                <p>
                  {t("home.hiw.requests_desc", {
                    defaultValue: "Receive service requests in your area",
                  })}
                </p>
              </div>
              <div className="homepage-howitworks-card">
                <div className="homepage-howitworks-icon secondary">
                  <i className="fas fa-tools" />
                </div>
                <h4>
                  3.{" "}
                  {t("home.hiw.provide", { defaultValue: "Provide Service" })}
                </h4>
                <p>
                  {t("home.hiw.provide_desc", {
                    defaultValue: "Deliver quality service to customers",
                  })}
                </p>
              </div>
              <div className="homepage-howitworks-card">
                <div className="homepage-howitworks-icon secondary">
                  <i className="fas fa-money-bill-wave" />
                </div>
                <h4>4. {t("home.hiw.earn", { defaultValue: "Earn Money" })}</h4>
                <p>
                  {t("home.hiw.earn_desc", {
                    defaultValue: "Get paid instantly for your excellent work",
                  })}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      {/* HOW TO START WITH HelpNao */}
      {!isLoggedIn && (
        <section className="homepage-howitworks" id="how-to-start">
          <div className="homepage-howitworks-container">
            <div className="homepage-howitworks-header">
              <h2>
                {t("home.start.title", {
                  defaultValue: "How to Start with HelpNao",
                })}
              </h2>
              <p>
                {t("home.start.subtitle", {
                  defaultValue: "Simple steps to get started on our platform",
                })}
              </p>
            </div>

            {/* Service Seekers Section */}
            <div className="homepage-start-section">
              <div className="homepage-start-grid">
                {/* Left Column - Text Content */}
                <div className="homepage-start-content seekers">
                  <div className="homepage-start-content-inner">
                    <h3>
                      {t("home.start.seeking_title", {
                        defaultValue: "Searching For",
                      })}{" "}
                      <span className="highlight-blue">
                        {t("home.start.services", {
                          defaultValue: "Services?",
                        })}
                      </span>
                    </h3>
                    <p className="homepage-start-subtitle">
                      {t("home.start.seeking_desc", {
                        defaultValue:
                          "How to place your order in just a few simple steps",
                      })}
                    </p>

                    {/* Steps */}
                    <div className="homepage-start-steps">
                      <div className="homepage-start-step">
                        <div className="homepage-start-step-number blue">1</div>
                        <div className="homepage-start-step-content">
                          <h4>
                            {t("home.start.choose_service", {
                              defaultValue: "Log in & Choose Your Service",
                            })}
                          </h4>
                          <p>
                            {t("home.start.choose_service_desc", {
                              defaultValue:
                                "Browse our categories and select the service you need",
                            })}
                          </p>
                        </div>
                      </div>
                      <div className="homepage-start-step">
                        <div className="homepage-start-step-number blue">2</div>
                        <div className="homepage-start-step-content">
                          <h4>
                            {t("home.start.book_schedule", {
                              defaultValue: "Book & Schedule",
                            })}
                          </h4>
                          <p>
                            {t("home.start.book_schedule_desc", {
                              defaultValue:
                                "Pick your preferred time and confirm your booking",
                            })}
                          </p>
                        </div>
                      </div>
                      <div className="homepage-start-step">
                        <div className="homepage-start-step-number blue">3</div>
                        <div className="homepage-start-step-content">
                          <h4>
                            {t("home.start.enjoy_service", {
                              defaultValue: "Enjoy Quality Service",
                            })}
                          </h4>
                          <p>
                            {t("home.start.enjoy_service_desc", {
                              defaultValue:
                                "Relax while our verified professionals take care of everything",
                            })}
                          </p>
                        </div>
                      </div>
                    </div>

                    <button className="homepage-start-btn blue">
                      {t("home.start.start_booking", {
                        defaultValue: "Start Booking Now",
                      })}
                    </button>
                  </div>
                </div>

                {/* Right Column - Illustration */}
                <div className="homepage-start-visual seekers">
                  <div className="homepage-start-mockup">
                    <div className="homepage-start-card">
                      <div className="homepage-start-icon-large blue">
                        {/* <i className="fas fa-calendar-check"></i> */}
                        <FontAwesomeIcon icon={ICON.calendarCheck} aria-hidden="true" />
                      </div>
                      <h4>
                        {t("home.start.easy_booking", {
                          defaultValue: "Easy Booking",
                        })}
                      </h4>
                      <p>
                        {t("home.start.easy_booking_desc", {
                          defaultValue: "Schedule services at your convenience",
                        })}
                      </p>

                      {/* Mock service icons */}
                      <div className="homepage-start-service-icons">
                        <div className="homepage-start-service-icon">
                          {/* <i className="fas fa-bolt"></i> */}
                          <FontAwesomeIcon icon={ICON.bolt} aria-hidden="true" />
                        </div>
                        <div className="homepage-start-service-icon">
                          {/* <i className="fas fa-broom"></i> */}
                          <FontAwesomeIcon icon={ICON.tools} aria-hidden="true" />
                        </div>
                        <div className="homepage-start-service-icon">
                          {/* <i className="fas fa-tools"></i> */}
                          <FontAwesomeIcon icon={ICON.ac} aria-hidden="true" />
                        </div>
                      </div>
                    </div>
                    <div className="homepage-start-bubble bubble-1"></div>
                  </div>
                </div>
              </div>
            </div>

            {/* Service Providers Section */}
            {/* <div className="homepage-start-section">
      <div className="homepage-start-grid providers">

        <div className="homepage-start-visual providers">
          <div className="homepage-start-mockup">
            <div className="homepage-start-card">
              <div className="homepage-start-icon-large green">
                <i className="fas fa-dollar-sign"></i>
              </div>
              <h4>
                {t("home.start.start_earning", { defaultValue: "Start Earning" })}
              </h4>
              <p>
                {t("home.start.start_earning_desc", {
                  defaultValue: "Turn your skills into income",
                })}
              </p>

              <div className="homepage-start-earnings">
                <div className="homepage-start-earning-item">
                  <span className="label">
                    {t("home.start.this_month", { defaultValue: "This Month" })}
                  </span>
                  <span className="value">৳3,250</span>
                </div>
                <div className="homepage-start-earning-item">
                  <span className="label">
                    {t("home.start.jobs_completed", { defaultValue: "Jobs Completed" })}
                  </span>
                  <span className="value">47</span>
                </div>
                <div className="homepage-start-earning-item">
                  <span className="label">
                    {t("home.start.rating", { defaultValue: "Rating" })}
                  </span>
                  <span className="value">4.9 ⭐</span>
                </div>
              </div>
            </div>
            <div className="homepage-start-bubble bubble-2"></div>
          </div>
        </div>

        <div className="homepage-start-content providers">
          <div className="homepage-start-content-inner">
            <h3>
              {t("home.start.want_earning", { defaultValue: "Want to Start" })}{" "}
              <span className="highlight-green">
                {t("home.start.earning", { defaultValue: "Earning?" })}
              </span>
            </h3>
            <p className="homepage-start-subtitle">
              {t("home.start.want_earning_desc", {
                defaultValue: "Join our community of professional service providers",
              })}
            </p>
            <p className="homepage-start-earning-highlight">
              💰{" "}
              {t("home.start.earn_amount", {
                defaultValue: "Earn up to ৳50,000+ Monthly",
              })}
            </p>

            <div className="homepage-start-steps">
              <div className="homepage-start-step">
                <div className="homepage-start-step-number green">1</div>
                <div className="homepage-start-step-content">
                  <h4>
                    {t("home.start.register_verify", {
                      defaultValue: "Register & Verify",
                    })}
                  </h4>
                  <p>
                    {t("home.start.register_verify_desc", {
                      defaultValue: "Sign up and complete our quick verification process",
                    })}
                  </p>
                </div>
              </div>
              <div className="homepage-start-step">
                <div className="homepage-start-step-number green">2</div>
                <div className="homepage-start-step-content">
                  <h4>
                    {t("home.start.get_requests", {
                      defaultValue: "Get Job Requests",
                    })}
                  </h4>
                  <p>
                    {t("home.start.get_requests_desc", {
                      defaultValue: "Receive service requests from customers in your area",
                    })}
                  </p>
                </div>
              </div>
              <div className="homepage-start-step">
                <div className="homepage-start-step-number green">3</div>
                <div className="homepage-start-step-content">
                  <h4>
                    {t("home.start.earn_grow", { defaultValue: "Earn & Grow" })}
                  </h4>
                  <p>
                    {t("home.start.earn_grow_desc", {
                      defaultValue: "Complete jobs, earn money, and build your reputation",
                    })}
                  </p>
                </div>
              </div>
            </div>

            <button className="homepage-start-btn green">
              {t("home.start.start_earning_today", {
                defaultValue: "Start Earning Today",
              })}
            </button>
          </div>
        </div>
      </div>
    </div> */}
          </div>
        </section>
      )}

      {/* COVERAGE SECTION */}
      <section className="homepage-coverage" id="coverage">
        <div className="homepage-coverage-container">
          <div className="homepage-coverage-header">
            <h2>
              {t("home.coverage.title", {
                defaultValue: "We're available in your city",
              })}
            </h2>
            <p>
              {t("home.coverage.sub", {
                defaultValue:
                  "Pick a city to see the active service areas we cover right now.",
              })}
            </p>
          </div>

          <div className="homepage-coverage-controls">
            <div className="homepage-coverage-selector">
              <label htmlFor="coverage-city">
                {/* <i className="fas fa-city"></i> */}
                <FontAwesomeIcon icon={ICON.city} aria-hidden="true" />
                {t("home.coverage.city", { defaultValue: "City" })}
              </label>
              <select
                id="coverage-city"
                value={selectedCityId}
                onChange={async (e) => {
                  const id = e.target.value;
                  setSelectedCityId(id);
                  setAreas([]);
                  await loadAreas(id);
                }}
              >
                {divisions.map((d) => (
                  <option key={d.Id} value={String(d.Id)}>
                    {d.name}
                  </option>
                ))}
              </select>
              <div className="homepage-coverage-count">
                {/* <i className="fas fa-map-pin"></i> */}
                <FontAwesomeIcon icon={ICON.mapPin} aria-hidden="true" />
                {t("home.coverage.areas_count", {
                  count: areas.length,
                  defaultValue: `${areas.length} active areas`,
                })}
              </div>
            </div>
          </div>

          <div className="homepage-coverage-areas">
            {areas.length === 0 ? (
              <div className="homepage-coverage-empty">
                {t("home.coverage.empty", {
                  defaultValue: "No active areas listed for this city yet.",
                })}
              </div>
            ) : (
              areas.map((a) => (
                <div key={a.Id} className="homepage-coverage-chip">
                  {/* <i className="fas fa-map-marker-alt"></i> */}
                  <FontAwesomeIcon icon={ICON.mapMarker} aria-hidden="true" />
                  <span>{a.name}</span>
                </div>
              ))
            )}
          </div>
        </div>
      </section>

      {/* NEW: EARN MONEY SECTION (after coverage) */}
      {!isLoggedIn && (
        <section className="homepage-earn" id="earn-with-HelpNao">
          {" "}
          {/* NEW */}
          <div className="homepage-earn-container">
            <div className="homepage-earn-content">
              <h2>
                {t("home.earn.title", {
                  defaultValue: "Earn money with your skills",
                })}
              </h2>
              <p>
                {t("home.earn.subtitle", {
                  defaultValue:
                    "Join thousands of professionals using HelpNao to find nearby jobs, manage bookings, and grow a steady income on your schedule.",
                })}
              </p>
              <button
                className="homepage-earn-btn"
                onClick={goToServitorSignup}
              >
                {/* <i className="fas fa-rocket" aria-hidden="true"></i> */}
                <FontAwesomeIcon icon={ICON.rocket} aria-hidden="true" />
                <span>
                  {t("home.earn.cta", { defaultValue: "Start Earning" })}
                </span>
              </button>
            </div>
          </div>
          {/* Full-width responsive banner */}
          <div className="homepage-earn-banner full-bleed">
            <img
              src={Banner}
              alt={t("home.earn.banner_alt", {
                defaultValue: "Earn with HelpNao",
              })}
              loading="lazy"
              decoding="async"
            />
          </div>
        </section>
      )}

      <FeedbackPage />

      {/* MOBILE APP SECTION */}
      {/* <section className="homepage-app" id="app">
        <div className="homepage-app-container">
          <div className="homepage-app-grid">
            <div className="homepage-app-content">
              <h2>
                {t("home.app.title", {
                  defaultValue: "Download Our Mobile App",
                })}
              </h2>
              <p>
                {t("home.app.subtitle", {
                  defaultValue:
                    "Get the full HelpNao experience on your phone. Book services, track providers, and manage your account on the go.",
                })}
              </p>

              <div className="homepage-store-buttons">
                <button
                  type="button"
                  className="homepage-store-btn"
                  onClick={() =>
                    window.open(
                      "https://play.google.com/store/apps/details?id=your.app.id",
                      "_blank"
                    )
                  }
                >
                  <img src={Playsore} alt="Get it on Google Play" />
                </button>
              </div>
            </div>

            <div className="homepage-app-mockup">
              <div className="homepage-phone-wrapper">
                <div className="homepage-phone-bubble bubble-1"></div>
                <div className="homepage-phone-bubble bubble-2"></div>
                <div className="homepage-phone-bubble bubble-3"></div>

                <div className="homepage-phone">
                  <div className="homepage-phone-notch"></div>
                  <div className="homepage-phone-screen">
                    <div className="homepage-phone-content">
                      <i className="fas fa-mobile-alt"></i>
                      <div className="homepage-phone-title">HelpNao</div>
                      <div className="homepage-phone-subtitle">
                        {t("home.app.card", { defaultValue: "App Preview" })}
                      </div>
                      <div className="homepage-phone-badge">
                        {t("home.app.cardSoon", {
                          defaultValue: "Coming Soon",
                        })}
                      </div>
                    </div>
                  </div>
                  <div className="homepage-phone-homebar"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      <Footer />

      {/* NEW: Floating Back-to-Top button */}
      <button
        type="button"
        className={`scrolltop-btn ${showScrollTop ? "show" : ""}`}
        onClick={scrollToTop}
        aria-label={t("home.back_to_top", { defaultValue: "Back to top" })}
        title={t("home.back_to_top", { defaultValue: "Back to top" })}
      >
        {/* <i className="fas fa-arrow-up" aria-hidden="true"></i> */}
        <FontAwesomeIcon icon={ICON.arrowUp} aria-hidden="true" />
      </button>
    </>
  );
};

export default Home;
